/* eslint-disable max-len */
module.exports = {
  aOfB: '{a} van {b}',
  about: 'Over',
  aboutThisItem: 'Over dit item',
  accessApiKeyManager: 'Verkrijg toegang tot de API Key Manager voor deze tenant.',
  accessControls: 'Toegangscontroles',
  accessControlsCopiedText: 'Toegangscontroles worden onmiddellijk bijgewerkt. Media veiligheidsmachtigingen zullen gedurende de volgende vijf minuten worden bijgewerkt.',
  accessControlsCopiedTitle: 'Toegangscontroles met succes gekopieerd',
  accessControlsCopyConfirmation: 'Dit zal alle bestaande toegangscontroles verwijderen van {to} en deze worden vervangen met toegangscontroles van {from}. Deze actie kan niet ongedaan gemaakt worden.',
  accessControlsDescription: 'Toegangscontroles bepalen wie deze media kan zien, op basis van geselecteerde Organisaties en Mediacategorieën.',
  accessControlsHelpText: 'Beheer toegangscontrole voor deze organisatie. Gebruikers hebben alleen toegang tot de vermelde media wanneer ze toestemming hebben om de mediacategorieën, waartot elk medium behoort, kunnen bekijken. Het toepassen op meerdere media binnen een organisatie kan enige tijd duren. Houd er rekening mee dat het even duurt voordat de wijzigingen zijn doorgevoerd en gebruik de knop Vernieuwen.',
  accessControlsIndeterminance: 'Opmerking: Ouderorganisaties hebben steeds toegang tot inhoud die werd toegewezen aan (een van) hun kinderen.',
  accessControlsRefreshWarning: 'U heeft wijzigingen die niet zijn opgeslagen. Als u vernieuwt worden deze verwijderd. Wilt u verdergaan?',
  accessControlsSaveSuccess: 'Toegangscontroles met succes opgeslagen',
  accessControlsTitleSection: 'Wanneer toegangscontroles op deze organisatie worden toegepast, worden ze via omgekeerde overerving ook automatisch gedelegeerd aan de volgende organisaties:',
  accessControlsTooltip: 'Organisaties hebben ook toegang tot content waartoe hun onderliggende organisaties toegang hebben. Het onderstaande raster bevat geen content waartoe deze organisatie toegang heeft via impliciete opwaartse delegering of omgekeerde overerving.',
  account: 'Account',
  accountErrorMessage: 'Foutmelding voor account',
  accountErrorMessageWarning: 'Het veld accountErrorMessage in de database wordt ingesteld op “Unauthorized” voor de tenant.',
  action: 'Actie | Acties',
  actionDelete: 'verwijderen',
  actionLoad: 'laden',
  actionPaste: 'Plakken',
  actionRun: 'uitvoeren',
  actionSave: 'Opslaan',
  actionUndoWarning: 'Deze actie kan niet ongedaan gemaakt worden.',
  actionUpload: 'uploaden',
  actualSize: 'Effectieve grootte',
  add: 'Toevoegen',
  addABookText: 'Een boek toevoegen',
  addABookToStart: '{addABookText} om te starten.',
  addAForm: 'Voeg een Vorm toe om te starten',
  addAFormOnly: 'Een formulier toevoegen',
  addAMedia: 'Media toevoegen',
  addAPIKey: 'Een API-Sleutel Toevoegen',
  addAPartCollection: 'Voeg een {partCollection} toe om te beginnen.',
  addAPrintSettingText: 'Printinstelling toevoegen',
  addAPrintSettingToStart: '{addAPrintSettingText} om te starten.',
  addASharedCart: 'Gedeelde winkelwagen toevoegen',
  addATag: 'Label toevoegen',
  addATemplate: 'Sjabloon toevoegen',
  addAllPartsCart: 'Voeg alle onderdelen toe aan de winkelwagen',
  addAnOrderQuoteEmailFormat: 'Een indeling voor een bestelling/offerte e-mail toevoegen',
  addBooks: 'Boeken Toevoegen',
  addBrowseFlow: 'Browse Flow Toevoegen',
  addChapter: 'Hoofdstuk toevoegen',
  addChildBrowseFlow: 'Browse Flow voor Kinderen Toevoegen',
  addComment: 'Voeg een opmerking toe',
  addExistingPart: 'Bestaand Deel Toevoegen',
  addGroupsToUsers: '{groups} groepen toevoegen aan {users} gebruikers',
  addItem: '{item} toevoegen',
  addMedia: 'Media Toevoegen',
  addPages: 'Pagina’s Toevoegen',
  addPart: 'Een onderdeel Toevoegen',
  addReports: 'Rapporten toevoegen',
  addRootBrowseFlow: 'Hoofd Browse Flow Toevoegen',
  addRow: 'Rij toevoegen',
  addTemplates: 'Sjablonen toevoegen',
  addToCartMessage: '{partNumber} succesvol toegevoegd',
  addToUserGroup: 'Toevoegen aan Groepen',
  addWidgetKey: 'Een widgetsleutel toevoegen',
  addedOn: 'Toegevoegd op',
  additionalInformation: 'Bijkomende Informatie',
  additionalNotification: 'Aanvullende Melding',
  additionalPartNumberDescription: 'Gebruik als bijkomend veld voor onderdeelnummer',
  address: 'Adres | Adressen',
  addressInUse: 'Een adres is momenteel ingesteld als standaardadres en kan niet verwijderd worden',
  addressInUseSubtitle: 'Om dit adres te verwijderen, moet u eerst dit adres als standaardadres verwijderen.',
  addressLine: 'Adreslijn {number}',
  addressState: {
    confirmationMessage: 'De volgende adressen zijn niet geverifieerd.',
    confirmationTitle: 'Weet u zeker dat u wil verder gaan met niet-geverifieerde adressen?',
    disabledVerification: 'Adresverificatie wordt uitgeschakeld voor het veld Bestelling / Offerte indienen',
    enteredAddress: 'Ingevoerd adres',
    failedToFetchSuggestions: 'Ophalen van adressuggesties mislukt.',
    failedToLoadDetails: 'Laden van adresdetails mislukt.',
    incomplete: 'Onvolledig adres',
    missingSubpremise: 'Ontbrekende sublocatie',
    noSuggestions: 'Geen suggesties gevonden. Bewerk het adres voor suggesties.',
    selectAddress: '(selecteer één optie)',
    subpremiseMessage: 'Dit adres lijkt voor een appartement of kantoorgebouw te zijn. Voeg jouw eenheid, appartement, kamernummer om het adres te voltooien.',
    suggested: 'Voorgesteld adres',
    unverified: 'Niet-geverifieerd adres',
    unverifiedHelpText: 'Kies een ander opgeslagen adres, of bewerk dit adres, of voeg een nieuw adres toe',
    unverifiedMessage: 'We kunnen dit leveradres niet verifiëren.',
    verified: 'Geverifieerd adres'
  },
  admin: 'Beheerder',
  adminCenter: 'Beheercentrum',
  adminCenterBanner: {
    bodyLabel: 'Bannerbody',
    enableLabel: 'Adminbanner inschakelen',
    headerGreenOption: 'Groen',
    headerLabel: 'Bannerkop',
    headerRedOption: 'Rood',
    headerYellowOption: 'Geel',
    title: 'Banner van Admin Center',
    typeLabel: 'Bannertype'
  },
  adminCenterMessage: 'Beheercentrum voor inhoud, gebruikers, bibliotheekinstellingen, rapportage en exporteren',
  adminMessage: 'Functies worden toegevoegd naarmate ze beschikbaar zijn',
  administration: 'Beheer',
  advancedFilters: 'Geavanceerde filters',
  affectedBookMedia: '{count} Boekmedia wordt bijgewerkt.',
  affectedProductPages: '{count} Productpagina\'s worden bijgewerkt.',
  affectedTemplateMedia: '{count} Boeksjablonen worden bijgewerkt.',
  after: 'Na',
  aggregatedFromChildren: 'Samenvoeging van Kinderen',
  aiAlgorithm: 'AI-scanner',
  algorithm: 'Algoritme',
  alignHorizontal: 'Horizontaal uitlijnen',
  alignVertical: 'Verticaal uitlijnen',
  all: 'Alle',
  allLibraryPages: 'Alle bibliotheekpagina\'s',
  allPagesAndBooks: 'Alle pagina\'s en boeken',
  allUsersDisabled: 'Alle gebruikers die tot de tenant behoren worden uitgeschakeld.',
  alphanumeric: 'Alfanumeriek',
  analyticsJSON: 'Analytics JSON',
  andCountMore: 'en {count} meer...',
  announcement: 'Aankondiging | Aankondigingen',
  any: 'Elk',
  apiAuthHeader: 'API Authorization Header',
  apiKey: 'API-Sleutel | API-Sleutels',
  apiKeyAdmin: 'API Key Admin',
  apiKeyCopied: 'Waarde van API Authorization Header gekopieerd naar klembord',
  apiKeyDeleteMsg: 'Verwijderen van deze API-Sleutel zal het gebruik ervan bij integraties uitschakelen',
  apiKeyDeleteTitle: 'Weet u zeker dat u deze API-Sleutel wilt verwijderen?',
  apiKeyDeleted: 'API-Sleutel verwijderd',
  apiKeyDeletedError: 'Fout bij verwijderen API-Sleutel',
  apiKeyInstructions: 'Sleutel wordt gegenereerd na het Opslaan',
  apiKeyManager: 'API-Sleutelmanager',
  apiKeyNameEmpty: 'Naam kan niet leeg zijn',
  apiKeyRegenError: 'Fout bij opnieuw genereren API-sleutel',
  apiKeyRegenMsg: 'Opnieuw genereren van deze API-Sleutel kan bestaande integraties uitschakelen',
  apiKeyRegenTitle: 'Weet u zeker dat u deze API-Sleutel opnieuw wilt genereren?',
  apiKeySaved: 'API-Sleutel Opgeslagen',
  apiKeyType: 'Type van API Key',
  appliesTo: 'Geldt voor',
  appliesToEmpty: 'Vereisen minstens één geselecteerd entiteitstype',
  appliesToPopulated: 'Instellen voor welke entiteiten de tags kunnen worden toegepast',
  apply: 'Toepassen',
  applyItem: '{item} Toepassen',
  applyToChildItems: 'Toepassen op onderliggende{item}',
  applyToPartOnly: 'Alleen op dit onderdeel toepassen',
  april: 'April',
  areYouSure: 'Weet u zeker dat u {item} wilt verwijderen?',
  areYouSureCopy: 'Weet u zeker dat u {item} wilt kopiëren?',
  areYouSureYouWantToDisableTheTenant: 'Weet u zeker dat u de tenant wil uitschakelen?',
  area: 'Gebied',
  assembly: 'Montage | Montages',
  assemblyConfirmationTitle: 'Wilt u het creëren van een montage voltooien?',
  assemblyCreatorHelpText1: 'Met deze functie kunt u een geselecteerde pagina in boeken invoegen op plaatsen waar u dit onderdeel {partName} tegenkomt, en het onderdeel en de geselecteerde pagina worden automatisch gelinkt via een hotpoint link. U kunt optioneel het invoegen beperken tot geselecteerde boeken.',
  assemblyCreatorHelpText2: 'De geselecteerde pagina wordt één keer per boek ingevoegd na de eerste verschijning van {partName}.',
  assemblyCreatorSuccessSubtitle: 'Hotpoints-links en wijzigingen aan de inhoudstafel van het boek zullen onmiddellijk gemaakt worden. Zoekresultaten zullen weergegeven worden van zodra het indexeren is voltooid.',
  assemblyCreatorSuccessTitle: 'Montage-opdracht aanmaken ingediend',
  assemblyStepOne: 'Stap 1: Selecteer de in te voegen pagina',
  assemblyStepTwo: 'Stap 2: Kies de boeken in welke u de pagina wenst in te voegen',
  asset: 'Bedrijfsmiddel | Bedrijfsmiddelen',
  assetsNotFound: 'Geen {type} Gevonden',
  assignBrowseFlow: 'Browse Flow Toewijzen',
  assignMedia: 'Media toewijzen',
  assignMediaToItem: 'Media toewijzen aan dit {item}.',
  assignedOrganizations: 'Toegewezen Organisaties',
  associateProductPage: 'Bestaande productpagina koppelen',
  associateProductPageDescription: 'Productpagina\'s aan deze media koppelen.',
  associateProductPageTip: 'Tip: Door te klikken op \'Nieuwe productpagina aanmaken\' wordt een tabblad geopend om een nieuwe productpagina toe te voegen als het product dat u wilt koppelen nog niet bestaat. Na het aanmaken van de nieuwe productpagina moet u terugkeren naar deze pagina om deze te koppelen.',
  associateProducts: 'Gekoppelde producten',
  atLeastFiveError: 'Selecteer een waarde die niet minder is dan 5.',
  attachRelatedPDFs: 'PDF’s van betrokken onderdelenpagina’s toevoegen',
  attachment: 'Bijlage | Bijlagen',
  attachmentEditorDescription: 'Voeg afbeeldingen, video’s en documenten rechtstreeks toe aan deze entiteit. Opmerking, deze kunt u terugvinden in het tabblad “Gerelateerd”.',
  attachmentEditorDescriptionPP: 'Voeg afbeeldingen, video’s en documenten rechtstreeks toe aan deze entiteit.',
  attachmentFileUploadSizeError: 'Bestandsgrootte overschrijdt de limiet van 50 MB',
  attachmentView: 'Bijlagen Weergeven',
  attributions: 'Bevoegdheden',
  august: 'Augustus',
  autoHideEmptyCards: 'Lege kaarten automatisch verbergen',
  autoHotpoint: 'Auto hotpoint',
  autoPopulate: 'Automatisch Invullen',
  automaticZoom: 'Automatische Zoom',
  availability: 'Beschikbaarheid',
  back: 'Achter',
  backCover: 'Cover Achteraan',
  backStitch: 'Stiksel Achter',
  backToLibrary: 'Terug naar Bibliotheek',
  backToSearch: 'Terug naar Zoekopdracht',
  badCredentials: 'Ongeldige Referenties',
  badDefaultValueMessage: 'De standaard waarde moet tussen {min} en {max} tekens liggen.',
  bahasaDescription: 'Bahasa Indonesische beschrijving',
  bahasaName: 'Bahasa Indonesische naam Bahasa',
  banner: 'Banner',
  banners: 'Banners',
  barColor: 'Kleur van de balk',
  before: 'Voor',
  beginTypingToFindAnything: 'Begin met typen om iets te vinden',
  beta: 'Beta',
  betaAccessKeys: 'Beta-toegangssleutels',
  betaReleaseVideo: 'Beta Release Video',
  betaResources: 'Betabronnen',
  blobFinder: 'BLOB Zoeker',
  body: 'Body',
  bom: 'Stuklijst',
  bomDefaultSupplier: 'Standaard leverancier van stuklijst',
  bomExportSuccess: 'Export van stuklijst succesvol',
  bomItem: 'Stuklijstitem',
  bomItems: 'Stuklijstitems',
  bomLayout: 'Lay-out van de Stuklijst',
  bomListOptions: 'BOM lijstopties',
  bomListSettings: 'BOM lijstinstellingen',
  book: 'Boek | Boeken',
  bookInserts: 'Boek Invoegingen',
  bookLabel: 'Boek | Boeken',
  bookPrintingDisable: 'Boek Afdrukken Uitschakelen',
  booksAndPagesDisplay: 'Weergave Boeken en Pagina’s',
  boost: 'Zoeken Boosten',
  boostDescription: 'Voeg een waarde toe die hoger is dan 1,5 om de zoekrelevantie te boosten voor deze tag wat betreft onderdeelnummers, media-identificatie en namen',
  boostRangeInvalid: 'Boost moet tussen 0,5 en 100,0 liggen',
  border: 'Rand',
  both: 'Beide',
  bottom: 'Onderzijde',
  branding: 'Branding',
  browse: 'Bladeren',
  browseComputer: 'Bladeren door Computer',
  browseFlow: 'Browse Flow | Browse Flows',
  browseFlowAssigned: 'Browse Flow Toegewezen',
  browseFlowCopyMessage: 'Voer een unieke naam in voor de nieuwe Browse Flow.',
  browseFlowDeleteMessage: 'Het verwijderen van een browse flow verwijdert niet alleen de browse flow maar ook al zijn browse flows voor kinderen.',
  browseFlowDeleted: 'Door verwijderde flows bladeren',
  browseFlowEmptyState: 'Geen Browse Flows gedefinieerd. {new} om te starten.',
  browseFlowHierarchy: 'Door flowhiërarchie bladeren',
  browseFlowMediaCategoryProductPageHelpText: 'Verwijder het momenteel toegevoegde zoekcriterium "Type: Productpagina” om de wijzigingen toe te passen.',
  browseFlowMoveToRoot: 'Plaats hier een node om een kind op het eerste niveau te maken',
  browseFlowNoAssignedOrgs: 'Geen toegewezen organisaties',
  browseFlowNoExistingCriteria: 'Er zijn geen zoekcriteria ingesteld voor deze browse flow. Gebruik de bovenstaande functies om zoekcriteria te selecteren.',
  browseFlowNoExistingCriteriaBelow: 'Er zijn geen zoekcriteria ingesteld voor deze browseflow. Gebruik de bediening onderaan om zoekcriteria te selecteren.',
  browseFlowSaveFailed: 'Browse Flow kon niet bijgewerkt worden',
  browseFlowSaved: 'Browse Flow opgeslagen',
  browseFlowSelectionRequired: 'Het selecteren van browseflow is vereist.',
  browseFlowSetDefaultSuccess: 'Standaard Browse Flow set',
  browseFlowThumbnailDeleteFailTitle: 'Miniatuur Verwijderen Mislukt',
  browseFlowThumbnailDeleteSuccessTitle: 'Miniatuur Verwijderen Gelukt',
  browseFlowThumbnailUploadFailTitle: 'Miniatuur Uploaden Mislukt',
  browseFlowThumbnailUploadSuccessTitle: 'Miniatuur Uploaden Gelukt',
  browseFlowTooManyOrgs: 'U heeft teveel organisaties om de huidige browse flow editor te gebruiken. Gelieve Documoto Support te contacteren via {email} voor hulp bij het bewerken van uw Documoto browse flows.',
  browserDeprecation: {
    text: 'In overeenstemming met de geleidelijke stopzetting van de ondersteuning van Internet Explorer (alle versies) door Microsoft en de daarmee verband houdende veiligheidsoverwegingen, zullen wij de toegang van gebruikers tot deze site via Internet Explorer (alle versies) na 30 september 2021 niet langer ondersteunen.',
    title: 'Beëindigingsmelding Browser'
  },
  browserPartiallySupport: 'Mogelijk ziet u esthetische verschillen en andere wijzigingen in deze browser.',
  buildHotpointLinks: 'Hotpointlinks Aanmaken',
  buildHotpointLinksInfo: 'Deze actie zal eerst alle bestaande hotpointlinks verwijderen van de boekenpagina’s, vervolgens nieuwe hotpointlinks creëren tussen onderdelen en corresponderende montagepagina’s',
  buildHotpointLinksTitle: 'Wilt u hotpointlinks aanmaken voor dit boek?',
  bulkApplyAllOrgs: 'In bulk toepassen op alle organisaties',
  bulkApplyAllOrgsModalMsg: 'Weet u zeker dat u toegang tot deze content wilt geven aan alle organisaties? Als u op \'Bevestigen\' klikt, wordt de toegang onmiddellijk toegekend aan alle organisaties en worden de wijzigingen in de toegangscontroles opgeslagen.',
  bulkExportConfirm: 'Wilt u {n} {unit} exporteren?',
  bulkExportLimit: 'Limiet is {limit} boeken per exportopdracht',
  bulkImport: 'Importeren in bulk',
  bulkIndexingLane: 'Strook voor bulkindexering',
  bulkInsert: 'Bulk Invoegen',
  bulkPageInsertJob: 'Pagina invoegen in bulk',
  bulkRemoveAllOrgs: 'In bulk verwijderen van alle organisaties',
  bulkRemoveAllOrgsModalMsg: 'Weet u zeker dat u de toegang tot deze content voor alle organisaties wilt verwijderen? Als u op \'Bevestigen\' klikt, wordt de toegang voor alle organisaties onmiddellijk verwijderd en worden de wijzigingen in de toegangscontrole opgeslagen.',
  business: 'Bedrijf',
  button: 'Knop',
  cameraSettings: 'Camera-instellingen',
  cancel: 'Annuleren',
  cancelAssemblyCreatorSubtitle: 'Uw montage creëren zal niet verwerkt worden.',
  cancelAssemblyCreatorTitle: 'Uw montage wegwerpen?',
  canceled: 'Geannuleerd',
  cannotExceed100: 'Kan 100% niet overschrijden',
  cannyWidgetLoadFailure: 'Forumfeedback kon niet worden geladen',
  cart: 'Winkelwagen | Winkelwagens',
  cartBehaviorDisabled: 'Prompt Hoeveelheid Toevoegen aan Winkelwagen Uitschakelen',
  cartBehaviorEnabled: 'Prompt Hoeveelheid Toevoegen aan Winkelwagen Inschakelen',
  cartBehaviorLabel: 'Gedrag Toevoegen aan Winkelwagen',
  cartColumn: 'Winkelwagen Kolom | Winkelwagen Kolommen',
  cartColumn1: '1e Winkelwagen Prijskolom',
  cartColumn2: '2e Winkelwagen Prijskolom',
  cartColumn3: '3e Winkelwagen Prijskolom',
  cartColumnPartLocationContent1: 'Het inschakelen van deze functie zal de volgende gevolgen hebben:',
  cartColumnPartLocationContent2: 'De uniciteit van onderdeelrijen in het winkelwagentje wordt ook gebaseerd op hun locatie binnen een contentonderdeel, indien van toepassing.',
  cartColumnPartLocationContent3: 'Deze instelling kan niet worden uitgeschakeld op organisatieniveau en zal van toepassing zijn op alle gebruikers.',
  cartColumnPartLocationContent4: 'Deze instelling mag niet worden ingeschakeld als u een Submit Cart-integratie hebt zonder eerst contact op te nemen met uw Documoto Klanten Succes Manager.',
  cartColumnPartLocationOption: 'Onderdeellocatiegegevens Inschakelen in Winkelwagen',
  cartColumnPartLocationTitle: 'Weet u zeker dat u Onderdeellocatiegegevens in Winkelwagen wilt inschakelen?',
  cartDisable: 'Winkelwagen Uitschakelen',
  cartEmailFailed: 'E-mail inhoud winkelwagen verzenden is mislukt',
  cartEmailSent: 'E-mail inhoud winkelwagen verzenden is gelukt',
  cartEnable: 'Winkelwagen Inschakelen',
  cartErpMessage: 'Succesvol verzonden naar Erp',
  cartImportError: 'Fout bij importeren van winkelwagen',
  cartLoadedWithItemsRemoved: '{count} item(s) verwijderd omdat u geen machtiging hebt om ze op dit moment te bestellen',
  cartSaveEnable: 'Winkelwagen Opslaan Inschakelen',
  cartSharedAddEdit: 'Gedeelde Winkelwagens Toevoegen/Bewerken',
  cartUpdated: 'Winkelwagentje Bijgewerkt',
  cartUpdatedAndRemovedCount: 'Winkelwagen bijgewerkt; {count} niet bestelbare onderdelen verwijderd',
  category: 'Categorie | Categorieën',
  categoryCreated: 'Categorie Aangemaakt',
  categoryNotFoundError: '403: De entiteitcategorie kan niet worden gevonden',
  categoryUpdated: 'Categorie Bijgewerkt',
  centimeter: 'Centimeter | Centimeters',
  changeNotification: 'Melding wijzigen',
  changeScope: '{n} {type} zal worden beïnvloed',
  changeUserOrganization: 'Organisatie Wijzigen',
  chapter: 'Hoofdstuk | Hoofdstukken',
  chapterHeader: 'Hoofdstuk Koptekst',
  chaptersOnly: 'Alleen Hoofdstukken',
  charLimitHelpText: 'Voer tussen {min} en {max} tekens in',
  chineseDescription: 'Chinese beschrijving',
  chineseName: 'Chinese naam',
  circle: 'Cirkel',
  city: 'Plaats',
  className: 'Klassenaam',
  classicAdminMessage: 'Hiermee wordt u doorgestuurd naar Flex om de beheerdermodules te gebruiken.',
  classicAdmins: 'Klassieke Beheerders',
  classicExporter: 'Klassieke Exporteur',
  classicExporterMessage: 'Oude Flash-gebaseerde inhoud exportmodule',
  classicOrganizationAdmin: 'Klassiek Organisatiebeheer',
  classicOrganizationAdminMessage: 'Oude Flash-gebaseerde beheermodule voor het beheren van organisaties en gebruikers',
  classicPublisher: 'Klassieke Uitgever',
  classicPublisherMessage: 'Oude Flash-gebaseerde uitgevermodule voor contentcreatie en printinstellingen',
  classicReporting: 'Klassieke Rapportage',
  classicReportingMessage: 'Oude Flash-gebaseerde rapportagemodule',
  classicTenantAdmin: 'Klassiek Tenantbeheer',
  classicTenantAdminMessage: 'Oude Flash-gebaseerde beheermodule voor instellingen van alle tenants',
  clear: 'Wissen',
  clearFilters: 'Filters Wissen',
  clearHotpoints: 'Hotpoints wissen',
  clearItemNumber: 'Itemnummer wissen',
  clearItemNumberMessage: 'Het wissen van het itemnummer zal leiden tot het verwijderen van de volgende gegevens:',
  clearItemNumberTitle: 'Wilt u het itemnummer wissen?',
  clearSearch: 'Zoekopdracht wissen',
  clickAction: 'Klikactie',
  clickHereToUpload: 'Zet het bestand hier neer of klik om een overschrijving te uploaden.',
  clickMagnifyingGlass: 'Klik op het vergrootglas om onmiddellijk naar Advanced Search te gaan.',
  clickOkToContinue: 'Klik op “OK” om door te gaan.',
  clickToDownload: 'Klik om te Downloaden',
  clickToEnlarge: 'Klik om te vergroten',
  clickToOpen: 'Klik om te Openen',
  clipboard: 'Klembord',
  clipboardAccessError: 'Pas uw browserinstellingen aan om toegang tot het Klembord mogelijk te maken.',
  close: 'Sluiten',
  closed: 'Gesloten',
  collapseAll: 'Alles Samenvouwen',
  color: 'Kleur | Kleuren',
  column: 'Kolom | Kolommen',
  columnItemType: {
    customText: 'Aangepaste Tekst',
    documentTitle: 'Documenttitel',
    horizontalLine: 'Horizontale Lijn',
    pageName: 'Paginanaam',
    pageNumber: 'Paginanummer',
    printDate: 'Printdatum',
    tenantName: 'Naam Huurder',
    userName: 'Gebruikersnaam'
  },
  columnMapping: 'Kolom-Kaarten',
  columnName: 'Kolomnaam',
  combinedPage: 'Gecombineerde Pagina',
  combinedPageMessage: 'Diagram bovenaan, onderdelenlijst onderaan',
  comingSoon: 'Komt Binnenkort',
  commaDelimited: 'Door komma‘s gescheiden',
  comment: 'Opmerking | Opmerkingen',
  commentAdded: 'Opmerking toegevoegd',
  commentCannotBeEmpty: 'Opmerking mag niet leeg zijn',
  commentDeleted: 'Opmerking verwijderd',
  commentEdit: 'Opmerkingen Toevoegen/Bewerken',
  commentEditAll: 'Alle Opmerkingen Bewerken',
  commentUpdated: 'Opmerking bijgewerkt',
  commentView: 'Opmerkingen Weergeven',
  commerceSystem: 'Handelsysteem',
  completed: 'Voltooid',
  configuration: 'Configuratie | Configuraties',
  confirm: 'Bevestigen',
  confirmBrowseFlowApplyToChildren: 'Wilt u deze browse flow toepassen voor kinderorganisaties?',
  confirmBrowseFlowOverrideToChildren: 'Dit zal alle browse flow-overschrijvingen verwijderen die ingesteld zijn voor de kinderorganisaties.',
  confirmPrintSettingsApplyToChildren: 'Wilt u deze printinstelling toepassen voor kinderorganisaties?',
  confirmPrintSettingsOverrideToChildren: 'Dit zal alle printinstelling overschrijvingen verwijderen die ingesteld zijn voor de kinderorganisaties.',
  contains: 'Bevat',
  containsHeaderRow: 'Bevat koprij',
  content: 'Content | Contents',
  contentAccessControls: '{content} Toegangscontrole',
  contentEntity: 'Contententiteit | Contententiteiten',
  contentNotFound: 'Content niet gevonden',
  contentUpdatedQueueJob: 'Inhoud bijgewerkte wachtrij',
  contentViewerMoreInfo: 'Meer info',
  contourShape: 'Contourvorm',
  convertEntity: '{entity} Omvormen',
  convertToEntity: 'Omvormen naar {entity}',
  copiedPartNumber: 'Gekopieerd onderdeelnummer {partNumber}',
  copy: 'Kopiëren',
  copyAccessControls: 'Toegangscontroles Kopiëren',
  copyAccessControlsWarning: 'Dit zal alle toegewezen toegangscontroles van een geselecteerde Organisatie kopiëren naar deze huidige Organisatie',
  copyAndRetain: 'Kopiëren & Behouden voor Gebruik Tijdens Integratie',
  copyAndRetainWidget: 'Kopiëren & Behouden, dit is de enige keer dat de waarden van de widgetautorisatie voor u zichtbaar zal zijn in de applicatie',
  copyAtoB: '{a} naar {b} Kopiëren',
  copyBranches: 'Branches kopiëren',
  copyBranchesMessage: 'Kopieer geselecteerde branches van de bron browseflow naar de doel browseflow.',
  copyContent: '{type} Kopiëren? {name}',
  copyItem: '{item} Kopiëren',
  copyItemQuestion: '{item} kopiëren?',
  copyMeMessage: 'Stuur me een kopie van dit bericht',
  copyPartNumberToClipboard: 'Kopieer {label} naar plakbord',
  copyProduct: 'Product kopiëren',
  copyTo: 'Kopiëren naar {target}',
  copyingItem: 'Kopiëren van {item}',
  copyrightMessage: '© 2010-{year} Documoto Inc. Alle rechten voorbehouden.',
  count: 'Count',
  country: 'Land | Landen',
  coverAmpStitchPages: 'Voorpagina’s & Pagina’s Stikken',
  coverPages: 'Voorpagina’s',
  createAssembly: 'Montage Aanmaken',
  createNewProductPage: 'Nieuwe productpagina creëren',
  created: 'Aangemaakt',
  createdBy: 'Aangemaakt door {name}',
  createdDate: 'Aanmaakdatum',
  createdOn: 'Aangemaakt op',
  currentPassword: 'Huidig Wachtwoord',
  custom: 'Aangepast',
  czechDescription: 'Tsjechische beschrijving',
  czechName: 'Tsjechisch naam',
  dashboard: 'Dashboard | Dashboards',
  dashboardLibrary: 'Dashboard Library',
  dataInsights: 'Data Insights',
  dataInsightsInfoMessage: 'Reporting and Dashboard Center voor inzichten in content, gebruikers en bibliotheek.',
  dataMapping: 'Gegevensmapping/Voorbeeldgegevens (tot 10 rijen)',
  dataOptions: 'Gegevensopties',
  date: 'Datum',
  dateModified: 'Wijzigingsdatum',
  debugPageBuilderPLZ: 'Paginabouwer PLZ debuggen',
  december: 'December',
  decreaseHotpoint: 'Hotpoint verminderen',
  'default': 'Standaard',
  defaultAddress: 'Standaard Adres',
  defaultBrowseFlow: 'Standaard Browse Flow',
  defaultCurrencyCode: 'Standaard Valutacode',
  defaultCurrencySymbolOn: 'Standaard valutasymbool aan',
  defaultEmailRecipient: 'Standaard E-mail Ontvanger | E-mail Ontvangers',
  defaultImage: 'Standaard Afbeelding | Standaard Afbeeldingen',
  defaultImagesManager: 'Standaard Beheerder Afbeeldingen',
  defaultItemImage: '{item} Standaard Afbeelding',
  defaultPartsListLayout: 'Standaard Lay-out Onderdelenlijst',
  defaultPartsListLayoutHelp: 'Standaard lay-out onderdelen links of onderaan de illustratie',
  defaultSearchMode: 'Standaard Zoekmodus',
  defaultSearchModeHelp: 'Standaard globale zoekmethode voor \'bevat\' of \'gelijk aan\'',
  defaultSortMode: 'Standaard Sorteermodus',
  defaultSupplier: 'Standaardleverancier',
  defaultTocStateOpen: 'Standaard INHOUDSTAFEL Status Open',
  defaultTocStateOpenHelp: 'Bepaalt of de INHOUDSTAFEL automatisch moet openen wanneer u een boek bekijkt',
  defaultUom: 'Standaard UOM',
  defaultValue: 'Standaard Waarde',
  defaultView: 'Standaard weergave',
  defaults: 'Standaarden',
  defaultsAndCapabilities: 'Standaarden en Mogelijkheden',
  'delete': 'Verwijderen',
  deleteAll: 'Overnemen Van Ouder',
  deleteAnyPartnerApiKeys: 'Verwijder alle Partner API Keys die zijn verstrekt aan SmartEquip.',
  deleteContent: 'Weet u zeker dat u {type} wilt verwijderen? {name}',
  deleteFilesMessage: 'Weet u zeker dat u {count} bestand(en) wilt verwijderen?',
  deleteHotpointLinksTitle: 'Weet u zeker dat u hotpoint-link(s) wil verwijderen?',
  deleteMessage: 'Weet u zeker dat u dit wilt verwijderen?',
  deletePart: {
    affectedCarts: 'Uit alle winkelwagens die dit onderdeel bevatten, zal dat onderdeel permanent worden verwijderd.',
    deletingPartNumber: '{partNumber} wordt verwijderd.',
    infoOne: 'Verwijderde onderdelen zijn onmiddellijk van kracht in Library en Content Admin. Het verwijderde onderdeel kan nog gezocht worden tot een paar minuten later het herindexeren heeft plaatsgevonden.',
    infoTwo: 'Deze actie kan niet ongedaan worden gemaakt zonder hulp van Documoto Support. Na 90 dagen worden het verwijderde record en alle koppelingen definitief verwijderd.'
  },
  deletePartCollectionConfirmMsg: 'Weet u zeker dat u deze {partCollection} van de {productPage} wilt verwijderen?',
  deletePartInUse: {
    body: 'Documoto ondersteunt momenteel alleen het verwijderen van onderdelen die niet tot pagina´s behoren. Verwijder dit onderdeel van gepubliceerde of conceptpagina´s om verder te gaan met verwijderen.',
    submitLabel: 'Ga naar pagina waar dit wordt gebruikt',
    title: 'Dit onderdeel behoort tot pagina(´s) en kan niet worden verwijderd.'
  },
  deleteProductPage: {
    deletingIdentifier: '{identifier} wordt verwijderd.',
    infoOne: 'Verwijderde productpagina\'s zijn onmiddellijk van kracht in Library en Content Admin. De verwijderde productpagina kan nog gezocht worden tot een paar minuten later het herindexeren heeft plaatsgevonden.',
    infoTwo: 'Deze actie kan niet ongedaan worden gemaakt zonder hulp van Documoto Support. Na 90 dagen worden het verwijderde record en alle koppelingen definitief verwijderd.'
  },
  deleteRelated: 'Weet u zeker dat u {count} {type} wil verwijderen?',
  deleteSelectedCriteria: 'Geselecteerde Criteria Verwijderen',
  deleteTagsTitle: 'Weet u zeker dat u tag(s) wil verwijderen?',
  deleteTaxonMessage: 'Dit zal dit taxon, samen met de kinderen, voorgoed verwijderen. Bent u zeker dat u verder wilt gaan?',
  deleteTaxonomyMessage: 'Dit zal alle taxons verwijderen voor deze Organisatie of Tenant. Bent u zeker dat u verder wilt gaan?',
  deleteTenantSupplier: 'Weet u zeker dat u deze leverancier voor deze tenant wil verwijderen?',
  deletedItem: '{item} verwijderd',
  demo: 'Demo',
  description: 'Beschrijving',
  deselectAll: 'Deselecteer Alle',
  deselectCriteria: 'Deselecteer Criteria',
  detail: 'Detail | Details',
  diagonal: 'Diagonaal',
  diameter: 'Diameter',
  disable: 'Uitschakelen',
  disableAll: 'Alles uitschakelen',
  disableDocumotoTenant: 'Documoto Tenant uitschakelen',
  disableFwdReindex: 'Doorsturen van herindexeren doelmedia voor DSW uitschakelen',
  disableLibraryBannerImage: 'Afbeelding van Library Banner uitschakelen',
  disableSmartEquipModalTitle: 'Weet u zeker dat u deze licentie wil uitschakelen?',
  disableTEK: 'Direct URL Login uitschakelen',
  disableUserLogin: 'Gebruikersnaam/wachtwoord uitschakelen',
  disableUserLoginErrorMessage: 'Uw organisatie vereist SSO-authenticatie. Aanmelden met gebruikersnaam en wachtwoord wordt niet toegestaan voor uw gebruikersgroep. Meld u aan via SSO.',
  disableUserLoginTooltip: 'Het inschakelen hiervan vereist een werkende SSO-configuratie. Als SSO niet is ingesteld, zullen betrokken gebruikers hun toegang tot Documoto verliezen.',
  disabled: 'Uitgeschakeld',
  discard: 'Verwerpen',
  discardChanges: 'Wijzigingen verwerpen',
  discardQ: 'Wijzigingen verwerpen?',
  discountPrice: 'Prijs met korting',
  discounted: 'Korting',
  discountedPrice: 'Prijs met Korting',
  discountedTotal: 'Totaal met Korting',
  displayInOrdersList: 'Weergeven in Lijst met Orders',
  displayLocation: 'Locatie weergeven',
  displayOrder: 'Bestelling Weergeven',
  displayOrderDescription: 'Stelt de weergavevolgorde in van het dropdown menu van de Filters voor contenttypetags',
  displaySupplierPartInfo: 'Leverancier weergeven op onderdeelinfo',
  document: 'Document | Documenten',
  documentLabel: 'Document | Documenten',
  documentSettings: 'Documentinstellingen',
  documotoAcademy: 'Documoto Academy',
  documotoLicensePackage: 'Documoto-licentiepakket',
  domain: 'Domein',
  domainEmptyMessage: 'Allowed Domain mag niet leeg zijn',
  domainInvalidMessage: 'Een geldige domeinnaam is vereist',
  download: 'Downloaden',
  downloadBrowser: 'Download een van deze geweldige browsers.',
  downloadFailed: 'Fout tijdens downloaden van {name}',
  downloadStarted: 'Bezig met downloaden van {name}',
  draft: 'Concept| Concepten',
  draftBomDeleteTitle: 'Weet u zeker dat u dit deel van de pagina wil verwijderen?',
  draftBomDropError: 'Kan onderdelen niet meer dan 5 niveaus diep nesten',
  draftBomEmptyField: 'Ale velden in de onderdelenlijst moeten worden ingevuld',
  draftBomError: 'Fout bij manipuleren van stuklijst',
  draftBomMultipleDeleteTitle: 'Weet u zeker dat u deze onderdelen van de pagina wil verwijderen?',
  draftBomQuantityError: 'Hoeveelheid moet een getal zijn',
  draftPage: 'Conceptpagina',
  draftPageDelete: 'Concept verwijderen',
  draftPageDeleteMessage: 'Conceptpagina succesvol verwijderd.',
  draftPageDeleteWarning: 'Verwijderen van paginaconcept zal updates die bezig zijn verwijderen.',
  draftPageLastUpdated: 'Concept - Laatst bijgewerkt op {date} door {username}',
  draftPageLoadError: 'Concept kon niet worden geladen.',
  draftPageProcessingPlz: 'Pagina wordt geladen vanaf het PLZ-bestand',
  draftPagePublishInProgress: 'Taak om pagina te publiceren is bezig',
  draftPageSaveSuccess: 'Conceptpagina succesvol opgeslagen.',
  draftPageSaveUnsuccessful: 'Conceptpagina niet succesvol opgeslagen.',
  draftSheetImageHotpointsFailure: 'Kan geen {algoritme} hotpoints genereren voor draftsheet afbeelding.',
  draftValidationMessage: {
    empty: 'Geen validatiefouten/Waarschuwingen',
    hotpointOrHotpointLink: 'BOM item {item} heeft geen hotpoint(s)/hotpointkoppeling(en) gespecificeerd',
    item: 'WAARSCHUWING: Onderdeelnummer {partNumber} van stuklijst heeft geen gespecificeerd itemnummer',
    quantity: 'BOM item {item} heeft geen hoeveelheid gespecificeerd',
    supersede: 'Onderdeel {partNumber} heeft {supersedPartNumber} vervangen als gevolg van de opvolging.',
    tag: 'BOM item {item} tag {tagName} ontbrekende waarde van het tag',
    translationDescription: 'BOM item {item} ontbrekende {lang} vertaling van beschrijving',
    uom: 'BOM item {item} heeft geen meeteenheid gespecificeerd'
  },
  drawAutohotpointRegion: 'Teken {shape} grootte',
  drawMinimumArea: 'Teken minimaal gebied',
  dropFileMessage: 'Zet het bestand hier neer of klik om te uploaden.',
  duplicate: 'Dupliceren',
  duplicateSaveError: 'Dubbele invoer. Kan niet opslaan.',
  dutchDescription: 'Nederlandse beschrijving',
  dutchName: 'Nederlandse naam',
  dynamic: 'Dynamisch',
  dynamicNaming: 'Dynamische Naam Geven',
  ecommerce: 'e-Commerce',
  ecommerceEmailFormatCreated: 'Ecommerce e-mailindeling aangemaakt',
  ecommerceEmailFormatSaved: 'Ecommerce e-mailindeling opgeslagen',
  ecommerceLogo: 'e-Commerce Logo',
  ecommerceUseExtOrder: 'Extern bestelnummer e-commerce gebruiken',
  edit: 'Bewerken',
  editItem: 'Bewerk {item}',
  email: 'E-mailadres',
  emailAsCsv: 'E-mailen als CSV (Vereist Formaat voor Importeren)',
  emailAsXlsx: 'E-mailen als XSLX',
  emailBasicPartInfo: 'Basis onderdeelinformatie e-mailen',
  emailComments: 'Opmerkingen e-mailen',
  emailDetails: 'Details e-mailen',
  emailDisplayedCartColumns: 'Weergegeven winkelwagenkolommen e-mailen',
  emailFormat: 'E-mailindeling',
  emailFormatTemplate: 'Sjabloon e-mailindeling | Sjablonen e-mailindeling',
  emailList: 'E-maillijst',
  emailMessage: 'Een e-mail is vereist',
  emailRecipient: 'E-mail Ontvanger | E-mail Ontvangers',
  emailRecipientMessage: 'Deze e-mailadressen zullen een e-mail ontvangen wanneer de bestelstatus verandert in',
  emailSubject: 'Onderwerp e-mailen',
  emptyBomState: 'Geen stuklijstitems gedefinieerd voor pagina. Klik op +{add} om te beginnen',
  emptyMessage: {
    orderSuggestions: 'Het lijkt erop dat er nog geen bestelsuggesties zijn voor dit onderdeel.'
  },
  enable: 'Inschakelen',
  enable3d: '3D inschakelen',
  enable3dIllustrations: '3D-illustraties inschakelen',
  enable3dThumbnails: '3D-miniaturen inschakelen',
  enableAPIKeyAdmin: 'API-sleutel admin inschakelen',
  enableAll: 'Alles inschakelen',
  enableCommerce: 'Handel Inschakelen',
  enableEcommerceOrderManagement: 'Order Management inschakelen',
  enableExportToLinkOne: 'Exporteren naar LinkOne inschakelen',
  enableExportToSmartEquip: 'Exporteren naar SmartEquip inschakelen',
  enableExporter: 'Exporter inschakelen',
  enableIframeSupport: 'iFrame Support inschakelen',
  enableKnowledgeBase: 'AI-powered zoeken inschakelen',
  enableLibraryBetaFeatures: 'Betafuncties van Library inschakelen',
  enableMediaCategorySearch: 'Groeperen op mediacategorieën in contextuele zoekopdracht inschakelen',
  enablePDFDownloadWarning: 'Waarschuwing voor het downloaden van grote PDF inschakelen',
  enablePLZToDraft: 'PLZ-proces naar concept inschakelen',
  enablePerformanceLogging: 'Prestatielogging inschakelen',
  enableQuickAddToCart: 'Quick Add to Cart inschakelen',
  enableQuickAddToCartHelpContext: 'Instellen op ’Enable’ zal de functie Quick Add to Cart boven de content viewer voor deze content inschakelen.',
  enableRocketUi: 'Rocket User Experience Inschakelen',
  enableSmartEquipApiIntegration: 'SmartEquip API Integration inschakelen',
  enableWidgetLogo: 'Logo van Documoto-widget inschakelen',
  enableWidgets: 'Widgets inschakelen',
  enabled: 'Ingeschakeld',
  encryptedKey: 'Geëncrypteerde Sleutel',
  endDate: 'Einddatum',
  endDateBad: 'De startdatum moet gelijk zijn aan of voor de einddatum liggen.',
  enforceNumericSize: 'Numerieke Maat Forceren',
  englishDescription: 'Engelse beschrijving',
  englishName: 'Engelse naam',
  enterReportParameters: 'Rapportparameters Invoeren',
  enterUniqueNameForNewItem: 'Voer een unieke naam in voor het nieuwe {item}',
  enterValidEmail: 'Gelieve een geldig e-mailadres in te voeren',
  enterValidNumber: 'Gelieve een geldig nummer in te voeren',
  enterprise: 'Onderneming',
  entityType: 'Entiteitstype | Entiteitstypes',
  erp: 'ERP',
  erpEndpointConfig: 'ERP-eindpuntconfiguratie',
  erpPartInfo: 'Cacheduur ERP-onderdeelinfo in minuten',
  erpSystem: 'ERP-systeem',
  erpSystemSaved: 'ERP-systeem opgeslagen',
  erpSystems: 'ERP-systemen',
  error: 'Fout',
  errorDeletePageMessage: 'Er is een fout opgetreden tijdens het verwijderen van de pagina.',
  errorInputParsing: 'Probleem met parseren van invoerbestand.',
  errorPageMessage: 'Er is een fout opgetreden.',
  errorPageTitle: 'Er is hier iets fout...',
  errorType: {
    error: 'Fout',
    warning: 'Waarschuwing'
  },
  essential: 'Essentiële onderdeel | Essentiële onderdelen',
  eta: 'ETA',
  etlJob: 'ETL',
  exact: 'Exact',
  excelFile: 'Excel-bestand',
  existing: 'Bestaande',
  expandAll: 'Alles Uitklappen',
  'export': 'Exporteren',
  exportAsCSVDropdown: 'Exporteren als CSV',
  exportAsCsv: 'Exporteren als CSV (Vereist Formaat voor Importeren)',
  exportAsHtml: 'Exporteren als HTML',
  exportAsPdf: 'Exporteren als PDF',
  exportAsPlz: 'Exporteren als PLZ',
  exportAsXlsx: 'Exporteren als XLSX',
  exportBasicPartInfo: 'Basis Onderdeelinformatie Exporteren',
  exportCartToXlsxDisabled: 'Winkelwagen Rxporteren naar XLSX Uitschakelen',
  exportCartToXlsxEnabled: 'Winkelwagen Exporteren naar XLSX Inschakelen',
  exportDisplayedCartColumns: 'Weergegeven wWnkelwagenkolommen Exporteren',
  exportJob: 'Taak Exporteren',
  exportLane: 'Strook exporteren',
  exportMessage: 'Exporttaak succesvol verzonden.',
  exportParts: 'Onderdelen exporteren',
  exportPartsXlsx: 'Onderdelen exporteren naar XLSX',
  exportSearch: 'Zoeken Exporteren',
  exporter: 'Exporteur',
  exporterMessage: 'Hiermee kunt u inhoud exporteren',
  external: 'Extern | Externen',
  externalUrl: 'Externe URL',
  faceted: 'Gefacetteerd',
  facetedTag: 'Filterwaarden moeten gefacetteerd zijn',
  facetedTagTooMany: 'Tag overschrijdt 1.000 unieke tag waardelimiet',
  failedAction: '{content} mislukt om {action}.',
  failedProcessContentSql: 'Procesinhoud mislukt omwille van niet-gemachtigde tekst. Upload de ondersteunde content opnieuw.',
  failedToCopy: '{content} mislukt om te kopiëren.',
  failedToDelete: '{content} mislukt om te verwijderen.',
  failedToLoad: '{content} kon niet worden geladen.',
  failedToSave: '{content} mislukt om op te slaan.',
  failedToSubmitFeedback: 'Verzenden van feedback mislukt.',
  failedToSubmitItem: 'Mislukt om {item} in te dienen',
  failedToUpdate: '{content} mislukt om bij te werken.',
  'false': 'Onwaar',
  faq: 'FAQ',
  favorites: 'Favorieten',
  favoritesLists: 'Lijst met Favorieten',
  february: 'Februari',
  feedbackForm: 'Feedback Indienen',
  feedbackFormMessage: 'Gelieve input te geven over de functies die u zou willen zien',
  field: 'Veld | Velden',
  fieldDefinition: 'Velddefinitie',
  fieldName: 'Veldnaam',
  file: 'Bestand | Bestanden',
  fileUpload: 'Bestand uploaden',
  filename: 'Bestandsnaam',
  filesSubmitted: 'Bestand(en) ingediend voor verwerking',
  fill: 'Vullen',
  filter: 'Filter | Filters',
  filterBoundsError: 'Filter moet 3 of meer karakters bevatten',
  filterBy: 'Filteren Op',
  filterOrgNameOnly: 'Filter: Alleen Organisatienaam',
  filterOrgParentNames: 'Filter: Organisatie & Bovenliggende Namen',
  filterable: 'Filterbaar',
  filterableTag: 'Filterbare Tag',
  finnishDescription: 'Finse beschrijving',
  finnishName: 'Finse naam',
  firstName: 'Voornaam',
  firstNameEmpty: 'Voornaam mag niet leeg zijn',
  fixedHotpointSize: 'Vast Hotpointformaat',
  font: 'Lettertype | Lettertypes',
  footer: 'Voettekst',
  forSearchTerm: 'voor {term}',
  forgotPassword: 'Wachtwoord Vergeten',
  forgotPasswordMessage: 'Een e-mail met instructies om uw wachtwoord opnieuw in te stellen wordt verzonden naar de opgegeven gebruikersnaam.',
  forgotPasswordSuccess: 'Als de opgegeven gebruikersnaam geldig is, wordt een e-mail met instructies om uw wachtwoord opnieuw in te stellen verzonden naar het gekoppelde adres.',
  form: 'Vorm | Vormen',
  formCount: 'Formuliertelling',
  formName: 'Formuliernaam',
  formType: 'Formuliertype',
  format: 'Formaat',
  formattingOptions: 'Indelingopties',
  freezeImage: 'Afbeelding bevriezen',
  frenchDescription: 'Franse beschrijving',
  frenchName: 'Franse naam',
  fri: 'Vr.',
  from: 'Van',
  fromDate: 'Van Datum',
  frontCover: 'Cover Vooraan',
  frontStitch: 'Stiksel Voor',
  fullScreen: 'Volledig scherm',
  gdprFaqs: 'Veelgestelde Vragen over GDPR',
  gdprMessage: 'Door aan te melden in deze sectie van onze website begrijpt u dat wij essentiële cookies gebruiken. Deze cookies zijn essentieel om u door onze Services te laten navigeren. Zonder deze cookies kunnen we de door u gevraagde services niet aanbieden. Raadpleeg voor meer informatie ons {policy}.',
  general: 'Algemeen',
  generalSearch: 'Algemene Zoekopdracht',
  generalSearchCriteriaAlreadySet: 'Zoekcriteria "Algemeen zoeken" is al ingesteld.',
  generic: 'Generiek',
  germanDescription: 'Duitse beschrijving',
  germanName: 'Duitse naam',
  goTo: 'Ga naar',
  goToHome: 'Ga naar Startpagina',
  goToJobManager: 'Ga naar Taakmanager',
  goToPartCollections: 'Ga naar {partCollections}',
  goToSearch: 'Ga naar Zoekopdracht',
  gotIt: 'Hebbes',
  hashKey: 'Hekjestoets',
  header: 'Koptekst',
  headerAmpFooter: 'Kop- en Voettekst',
  help: 'Help',
  helpCenter: 'Helpcentrum',
  hideBookInSearchAndRecent: 'Boeken in Zoekresultaten & Recent Toegevoegd Verbergen',
  hideDuplicatePages: 'Duplicaatpagina‘s Verbergen',
  hidePageInSearchAndRecent: 'Pagina’s in Zoekresultaten & Recent Toegevoegd Verbergen',
  hidePartInSearchAndRecent: 'Onderdelen in Zoekresultaten & Recent Toegevoegd Verbergen',
  highlightDescription: 'Onderdelen met deze tag in onderdelenlijst markeren',
  history: 'Geschiedenis',
  home: 'Startpagina',
  homePageSettings: 'Instellingen homepagina',
  homepageOnly: 'Alleen startpagina',
  horizontal: 'Horizontaal',
  host: 'Host',
  hotpoint: 'Hotpoint | Hotpoints',
  hotpointCalloutBehavior: 'Hotpoint afroepgedrag',
  hotpointLink: 'Hotpoint-link | Hotpoint-links',
  hotpointLinksWillBeCreated: 'Hotpoint links zullen aangemaakt worden in {count} {content}',
  hotpointShift: 'Hotpoint (Shift H)',
  hotpointZoomBehavior: 'Hotpoint zoomgedrag',
  hotpointsGenerated: '{count} hotpoints gevonden op de afbeelding.',
  hourlyDWSRequestLimit: 'Uurlimiet voor DWS-aanvragen',
  hourlyRESTRequestLimit: 'Uurlimiet voor REST-aanvragen',
  htmlUiUserSwitchEnabled: 'HTML UI gebruikersschakelaar ingeschakeld',
  hungarianDescription: 'Hongaarse beschrijving',
  hungarianName: 'Hongaarse naam',
  icon: 'Pictogram',
  id: 'ID',
  identifier: 'Identificatie',
  identifierRequiredErrorMessage: 'Een identificator is vereist',
  ignore: 'NEGEREN',
  ignoreAccessControls: 'Toegangscontroles Negeren',
  ignoreMatchingTranslations: 'Negeer vertalingen met overeenkomende landinstellingen bij het Importeren',
  illustration: 'Illustratie | Illustraties',
  image: 'Afbeelding | Afbeeldingen',
  imageDeleteMessage: 'Weet u zeker dat u deze pagina-afbeelding wil verwijderen?',
  imageDimensionsExceededMessage: 'De maximale afbeeldingsgrootte in Documoto is 65,5 megapixels (8.191 X 8.191 pixels).  De afbeelding die u probeert op te laden heeft de maximale grootte overschreden en kan niet worden geladen. Klik op “Formaat wijzigen" om Documoto toe te staan om het formaat te wijzigen en de afbeelding in te voegen, of “Annuleren" om de afbeelding te bewerken en handmatig in te voegen',
  imageOptimizer: 'Afbeelding Optimizer',
  imageSaveFail: 'Afbeelding opslaan mislukt',
  imageSaveSuccess: 'Afbeeldingen succesvol bijgewerkt',
  imageSizeExceededMessage: 'De maximale bestandsgrootte voor Documoto is {size} megabytes. De afbeelding die u probeert op te laden heeft de maximale grootte overschreden en kan niet worden geladen. Gelieve de afbeelding te verkleinen om deze toe te voegen aan deze pagina.',
  imageSizeExceededTitle: 'Maximale afbeeldingsgrootte overschreden',
  imageUploadFailure: 'Afbeelding opladen mislukt',
  'import': 'Importeren',
  importBOM: 'BOM importeren',
  importBOMError: 'Verwerking van voorbeeldgegevens mislukt, controleer de invoerbron opnieuw',
  importName: 'Importnaam',
  importParts: 'Onderdelen importeren',
  inCart: 'In Winkelwagen',
  inCartDescription: 'Tags in winkelwagen weergeven',
  inPartsList: 'In Onderdelenlijst',
  inPartsListDescription: 'Tags in onderdelenlijst weergeven',
  inch: 'Inch | Inches',
  includeComments: 'Opmerkingen Opnemen',
  includeCommentsAuthorAndDate: 'Auteur en Datum Opmerking Opnemen',
  includeHeaderRow: 'Koprij toevoegen',
  includeImages: 'Afbeeldingen Opnemen',
  includeNewParts: 'Inclusief alleen „nieuwe” onderdelen (niet in Documoto)',
  includePagePartDetails: 'Details op pagina onderdeelniveau toevoegen',
  includePagesIndex: 'Pagina-index ‘Opnemen',
  includePartDetails: 'Details op onderdeelniveau toevoegen',
  includePartsIndex: 'Onderdelenindex Opnemen',
  includePartsList: 'Onderdelenlijst Opnemen',
  includeSubChapters: 'Subhoofdstukken Opnemen',
  includeWatermark: 'Inclusief watermerk?',
  increaseHotpoint: 'Hotpoint verhogen',
  indefinitely: 'Oneindig',
  indexIncludeTimestamp: 'Index omvat tijdstempel',
  indexLane: 'Indexstrook',
  indexQueueJob: 'Indexwachtrij',
  indexed: 'Geïndexeerd',
  indexingConfiguration: 'Indexeringsconfiguratie',
  info: 'Info',
  information: 'Informatie',
  inherit: 'Overnemen',
  inherited: 'Geërfd',
  inheritedParent: 'Overgenomen van Ouder.',
  inputSource: 'Invoerbron',
  inputSpecification: 'Invoerspecificatie',
  inputType: 'Inputtype',
  inputTypeListboxWarning: 'Sorteerinstellingen zullen weergegeven worden na het opslaan',
  insertDataField: 'Gegevensveld invoegen',
  integration: 'Integratie | Integraties',
  integrationsAddPartToErpCart: '{action} Onderdeel Toevoegen aan ERP-Wagentje',
  integrationsAddToShoppingCartPricingFromErp: '{action} Toevoegen aan Winkelwagen - Prijzen uit ERP',
  integrationsDisableErp: 'ERP Uitschakelen',
  integrationsDoErpForQuotes: 'ERP voor Offertes gebruiken',
  integrationsEnableErp: 'ERP Inschakelen',
  integrationsEnableFetchPartInfoFromErp: 'Onderdeleninfo Verzamelen van ERP Inschakelen',
  integrationsEnableScopeErp: 'ERP {scope} Inschakelen',
  integrationsEnableSendShoppingCartToErp: 'Winkelwagen naar ERP Sturen Inschakelen',
  integrationsEnableSyncPoAddressWithErp: 'Postadres Synchroniseren met ERP Inschakelen',
  integrationsErpAvailabilityMappedFrom: 'ERP Beschikbaarheid Toegewezen Van',
  integrationsErpCurrencyCodeMappedFrom: 'ERP Valutacode Toegewezen Van',
  integrationsErpDiscountedPriceMappedFrom: 'ERP Promotieprijs Toegewezen Van',
  integrationsErpEtaMappedFrom: 'ERP ETA Toegewezen Van',
  integrationsErpMappings: 'ERP-Kaarten',
  integrationsErpRetailPriceMappedFrom: 'ERP Retailprijs Toegewezen Van',
  integrationsErpWholesalePriceMappedFrom: 'ERP Groothandelprijs Toegewezen Van',
  integrationsInvokeGetPartInfoFromClient: 'GetPartInfo van Klant Inroepen',
  integrationsParseAddressForType: 'Adres Analyseren voor Type',
  integrationsShoppingCartAndPartsTitle: 'Winkelwagen en Onderdelen',
  integrationsShoppingCartAvailability: '{action} Winkelwagen Beschikbaarheid',
  integrationsShoppingCartEtaFromErp: '{action} Winkelwagen - ETA van ERP',
  internalApiKey: 'Interne API Key',
  internalDescription: 'Interne Beschrijving',
  internalName: 'Interne Naam',
  internalNameOptional: 'Uw identificatie voor de tag',
  internalNameRequired: 'Er is een naam vereist',
  invalidDecimals: 'Slechts twee decimale plaatsen zijn toegestaan',
  invalidField: '{field} is ongeldig',
  invalidFileType: 'Bestandstype niet ondersteund. Zie het Documoto Support Center voor een volledige lijst van ondersteunde bestandsextensies.',
  isSearchable: 'Is Zoekbaar',
  isSystem: 'Is Systeem',
  italianDescription: 'Italiaanse beschrijving',
  italianName: 'Italiaanse naam',
  item: '#',
  itemAlt: 'Item',
  itemCopied: '{item} gekopieerd',
  itemDeleted: '{item} verwijderd',
  itemDetails: 'Itemsdetails',
  itemInProgress: '{item} in behandeling',
  itemInformation: '{item} informatie',
  itemMustBeLteItem: '{itemA} moet gelijk zijn aan of voor {itemB} komen.',
  itemMustBeUnique: '{item} moet uniek zijn',
  itemMustBeUniqueAndNotEmpty: '{item} moet uniek zijn en is vereist',
  itemName: '{item} naam',
  itemSaved: '{item} opgeslagen',
  itemSpecification: 'Itemspecificatie',
  january: 'Januari',
  japaneseDescription: 'Japanse beschrijving',
  japaneseName: 'Japanse naam',
  job: 'Taak | Taken',
  jobManager: 'Taakbeheerder',
  jobManagerMessage: 'Taken exporteren, publiceren en afdrukken/downloaden',
  july: 'Juli',
  june: 'Juni',
  knowledgeBase: {
    config: {
      fetchUsage: 'Gebruik ophalen',
      maxTokensDefault: 'Standaard max tokens per maand',
      maxTokensOverride: 'Max tokens per maand overschreden',
      noData: 'Geen configuratiegegevens beschikbaar.'
    },
    errors: {
      maxFileSizeExceeded: 'Bestand overschrijdt de maximale bestandsgrootte voor Knowledge Base.',
      maxTokensExceeded: 'U hebt de tokenlimiet bereikt.',
      pageNavigationFailed: 'Navigeren naar pagina mislukt.'
    },
    feedback: {
      prompt: 'Bedankt om ons in te lichten. Wat was er fout met dit antwoord?',
      reasons: {
        hardToUnderstand: 'Moeilijk te begrijpen',
        incorrect: 'Onjuist',
        missingInfo: 'Ontbrekende info',
        offTopic: 'Off-topic'
      },
      submitted: 'Uw feedback is verzonden.'
    },
    library: {
      buttonText: 'Vraag het AI',
      disclaimer: 'Documoto AI kan fouten maken. Controleer antwoorden op nauwkeurigheid.',
      inputPlaceholder: 'Stel een vraag...',
      noContent: 'Geen context beschikbaar voor dit document.',
      promptDefault: 'Vragen worden alleen beantwoord over dit document. Stel één vraag per keer.',
      reference: 'PDF-referentie',
      serviceError: 'Fout bij het genereren van context.',
      title: 'AI-powered zoeken'
    },
    tenantKnowledgeBase: 'Tenant knowledge base',
    usage: {
      inputTokens: 'Totaal aantal inputtokens',
      noData: 'Geen gebruiksgegevens beschikbaar.',
      outputTokens: 'Totaal aantal outputtokens',
      title: 'Overzicht van totaal gebruik',
      totalTokens: 'Totaal aantal gebruikte tokens'
    }
  },
  koreanDescription: 'Koreaanse beschrijving',
  koreanName: 'Koreaanse naam',
  label: 'Label | Labels',
  labelKey: 'Labelsleutel',
  landscape: 'Liggend',
  laneConfiguration: 'Strookconfiguratie',
  language: 'Taal',
  largePDFDownloadWarning: 'Omwille van de grote omvang van het PDF-bestand kan het langer duren dan normaal om het document te laden en weer te geven in de applicatie. Wees geduldig terwijl het bestand wordt gedownload om te kunnen bekijken.',
  lastGenerated: 'Laatst Gegenereerd',
  lastModifiedDate: 'Datum laatste wijziging',
  lastName: 'Achternaam',
  lastNameEmpty: 'Familienaam mag niet leeg zijn',
  lastUpdatedOn: 'Laatst bijgewerkt op',
  layout: 'Lay-out',
  layoutOptions: 'Lay-outopties',
  ledger: 'Grootboek',
  left: 'Links',
  legal: 'Juridisch',
  letter: 'Letter',
  library: 'Bibliotheek',
  libraryAdmin: 'Bibliotheek Beheer',
  libraryBannerLogo: 'Bannerlogo van bibliotheek',
  librarySettings: 'Bibliotheekinstellingen',
  librarySettingsDescription: 'Deze instellingen beheren verschillende bibliotheekelementen en opties. Wees voorzichtig bij het aanbrengen van wijzigingen. Contacteer Documoto Services voor meer info.',
  licenseConfiguration: 'Licentieconfiguratie',
  line: 'Lijn',
  lineTool: 'Lijngereedschap',
  link: 'Link | Links',
  listBox: 'Keuzelijst',
  listBoxValue: 'Lijstvak Waarde | Lijstvakken Waarden',
  listValue: 'Lijstwaarde | Lijstwaarden',
  load: 'Laden',
  loadMore: 'Laad meer',
  loading: 'Laden',
  loadingParts: 'Onderdelen laden',
  locale: 'Lokale',
  logiReportName: 'Logi-rapportnaam',
  logiReportToggle: 'Logi-rapport?',
  login: 'Aanmelden',
  loginBackground: 'Aanmelden Achtergrond',
  loginGDPRMessageBeginning: 'Deze website gebruikt cookies. Door deze website verder te gebruiken gaat u akkoord dat cookies worden gebruikt. Raadpleeg voor meer informatie onze ',
  loginGDPRMessageEnd: 'en onze',
  loginSSO: 'Aanmelden SSO',
  logo: 'Logo | Logo‘s',
  logout: 'Afmelden',
  lookupLoadParts: 'Opzoeken/laden onderdelen uit Documoto bij import',
  lowerBound: 'Ondergrens',
  mOfNShown: '{m} van {n} getoond',
  mToM: 'M2M',
  mainInfo: 'Hoofdinfo',
  mainLogo: 'Hoofdlogo',
  makePagesDivisibleBy: 'Maak Pagina’s Deelbaar Door:',
  manageItem: '{item} Beheren',
  management: 'Management',
  manuallyResetPassword: 'Wachtwoord handmatig opnieuw instellen',
  manuallySetPassword: 'Wachtwoord handmatig instellen',
  march: 'Maart',
  margin: 'Marge | Marges',
  markdown: 'Verminderen',
  maxCharHelpMessage: 'Stel eender welke waarde tussen {min} en {max} tekens in voor de maximale tekenlimiet.',
  maxCharacters: 'Maximaal aantal tekens',
  may: 'Mei',
  media: 'Media | Media',
  mediaBookDeleteMessage: 'Door deze media te verwijderen, zult u geen toegang meer hebben tot de inhoud, noch via de Bibliotheek, noch via Content Admin en het zal niet langer beschikbaar zijn voor gebruikers of Contentbeheerders. Alle delen of pagina’s in dit boek die niet in andere boeken worden gevonden, zullen ook niet meer beschikbaar zijn in de Bibliotheek.',
  mediaCategory: 'Mediacategorie | Mediacategorieën',
  mediaCategoryEditor: 'Mediacategorie-Editor',
  mediaCategoryName: 'Naam Mediacategorie',
  mediaCategoryNameMissing: 'Alle mediacategorieën moeten een naam hebben',
  mediaDeleteMessage: 'Als u dit sjabloon verwijdert, wordt het verwijderd van Content Admin en het zal niet langer beschikbaar zijn om te kopiëren naar nieuw Media.',
  mediaDeleteSuccessText: 'Het zal verwijderd worden van lijsten van zodra de indexering voltooid is.',
  mediaDescription: 'Mediabeschrijving',
  mediaIdentifier: 'Media-identificator',
  mediaIdentifierDescription: 'Het interne medianummer voor eindgebruikers om te zoeken',
  mediaName: 'Medianaam',
  mediaPrintSettingsSaveSuccess: 'Instellingen Media Afdrukken opgeslagen',
  mediaWhereUsed: 'Media Waar Gebruikt',
  menu: 'Menu',
  merge: 'Samenvoegen',
  mergeOrOverrideMessage: 'Wilt u deze items overschrijven of samenvoegen?',
  mergeWarning: 'Importeren van gegevens zal bestaande onderdelen bijwerken en de nieuwe items toevoegen',
  message: 'Bericht',
  messageLevel: 'Berichtniveau',
  messageMessage: 'Er is een bericht vereist',
  metadata: 'Metadata',
  microsite: 'Microsite | Microsites',
  micrositeAdmin: {
    cardSubtitle: 'Het gecomprimeerde inhoudsbestand en HTML-invoerinformatie',
    cardTitle: 'Inhoud van de site',
    errorRequiredFile: 'Een ZIP-bestand met de inhoud van de site is vereist',
    fieldFile: 'ZIP-bestand met de inhoud van de site',
    fieldPoint: 'HTML-invoerpunt'
  },
  minArea: 'Minimaal gebied',
  minAreaMessage: 'Minimale waarde is vereist De waarde mag een bereik van 1 tot 1500 niet overschrijden.  Moet een gehele waarde zijn.',
  minCharacters: 'Minimaal aantal tekens',
  minMaxCharHelpMessage: 'Stel eender welke waarde tussen {min} en {max} tekens in voor de minimale / maximale tekenlimiet. Het maximum moet groter of gelijk zijn aan het minimum.',
  mine: 'Mine',
  miscellaneous: 'Overige',
  mon: 'Ma.',
  month: 'Maand',
  moreInfo: 'Meer info',
  multipleAlternatingPages: 'Meerdere Afwisselende Pagina’s',
  multipleAlternatingPagesMessage: 'Diagram op pagina’s 1 en 3, onderdelenlijst op pagina’s 2 en 4.',
  multiplePages: 'Meerdere Pagina\'s',
  multiplePagesMessage: 'Diagram op afzonderlijke pagina gevolgd door onderdelenlijstpagina’s',
  myCart: 'Mijn winkelwagen | Mijn Winkelwagens',
  nItemsCreated: '{n} {items} Aangemaakt',
  nItemsDeleted: '{n} {items} Verwijderd',
  nOfMItems: '{n} van {m} {items}',
  name: 'Naam',
  nameDescriptionHelpText: 'De naam en optionele beschrijving',
  navigation: 'Navigatie',
  'new': 'Nieuw',
  newAPIKey: 'Nieuwe API-Sleutel',
  newERPSystem: 'Nieuw ERP-systeem',
  newItem: 'Nieuw {item}',
  newKeyGenerated: 'Nieuwe Integratiesleutel Gegenereerd, Kopieer & Bewaar voor toekomstig gebruik',
  newMediaCategory: 'Nieuwe Mediacategorie',
  newPassword: 'Nieuw Wachtwoord',
  newTenant: 'Nieuwe tenant',
  newWidgetKey: 'Nieuwe widgetsleutel',
  newWidgetKeyGenerated: 'Nieuwe widgetsleutel gegenereerd, kopieer en bewaar deze voor toekomstig gebruik',
  newsItem: 'Nieuwsitem | Nieuwsitems',
  noAPIKeys: 'Geen API-Sleutels gedefinieerd.',
  noData: 'Geen Gegevens',
  noFileSelected: 'Geen bestand geselecteerd',
  noFilesSelected: 'Geen Bestanden Geselecteerd',
  noFormsMessage: 'Geen vormen gedefinieerd',
  noIllustrationFound: 'Geen illustratie gevonden',
  noImageFound: 'Geen afbeelding gevonden',
  noItemAddedToTarget: 'Geen {item} toegevoegd aan het {target}. ',
  noItemAvailable: 'Geen {item} beschikbaar',
  noItemFound: 'Geen {item} gevonden.',
  noItemSelected: 'Geen {item} geselecteerd',
  noItemsFound: 'Geen Items Gevonden',
  noMediaDefined: 'Geen media gedefinieerd',
  noMoreResults: 'Geen resultaten meer',
  noPartCollectionsFound: 'Geen {partCollection} gevonden.',
  noPartsSelected: 'Geen onderdelen geselecteerd.',
  noPrice: 'Vraag voor een Prijs',
  noResults: 'Geen resultaten',
  noSearchResultsHelpText: 'Geen resultaten gevonden.',
  noSearchableCategories: 'Geen zoekbare categorieën',
  noSearchableTags: 'Geen zoekbare tags',
  noSuggestions: 'Geen suggesties voor de zoekterm',
  noSupercedingPartsFoundForPartNumber: 'Er zijn geen vervangende onderdelen gevonden voor dit onderdeelnummer.',
  noTagsFound: 'Geen tags gevonden',
  noTenantSuppliers: 'Geen leveranciers toegewezen aan de tenant.',
  noUnsavedChanges: 'Geen Onopgeslagen Veranderingen',
  noWidgetKeys: 'Geen widgetsleutels gedefinieerd.',
  node: 'Node',
  nonSearchableFieldsSuccessfullyUpdated: 'Niet-doorzoekbare velden succesvol bijgewerkt.',
  none: 'Geen',
  norwegianDescription: 'Noorse beschrijving',
  norwegianName: 'Noorse naam',
  notImplemented: 'Niet Geïmplementeerd',
  notMapped: 'Niet toegewezen',
  notOrderable: 'Niet Bestelbaar',
  notSelected: 'Niet geselecteerd',
  notification: 'Melding | Meldingen',
  notificationsMessage: 'Belangrijke aankondigingen en nieuws',
  november: 'November',
  numberOf: '# van {item}',
  numeric: 'Numeriek',
  october: 'Oktober',
  of: 'van',
  off: 'Uit',
  offlineContent: 'Offline Inhoud',
  ok: 'Ok',
  oldPassword: 'Oud wachtwoord',
  on: 'Aan',
  opacity: 'Ondoorzichtigheid',
  open: 'Openen',
  openItem: '{item} Openen',
  openTab: 'Open link in een nieuw tabblad',
  optimizeIndexJob: 'Index optimaliseren',
  optionalConfiguration: 'Optionele configuratie | Optionele configuraties',
  options: 'Opties',
  order: 'Bestelling | Bestellingen',
  orderAttachmentHelpText: 'U kunt maximaal 10 bestanden bijvoegen, ieder tot 50 MB groot. Toegestane bestandstypen: pdf, doc, docx, xls, xlsx, txt, rtf, ppt, pptx, xml, zip, jpg, jpeg, gif, png, bmp, tiff, tif, mp4, mpg, mpeg, avi, mov, rm, wmv, flv, f4v, svg',
  orderDisable: 'Bestelgeschiedenis Uitschakelen',
  orderEmailRecipient: 'Bestellingse-mail Ontvanger | Bestellingse-mail Ontvangers',
  orderEntity: 'Orderentiteit | Orderentiteiten',
  orderField: {
    nameMessage: 'Als u de naam van het Order-/Offerteveld wijzigt, zorg er dan voor dat u alle Order-/Offerteformulieren of E-mailindelingen die deze gebruiken, ook bijwerkt.'
  },
  orderFieldCopyMessage: 'Voer een unieke naam in voor het nieuwe Order-/Offerteveld',
  orderFieldUneditableRequired: 'Als u een Order-/Offerteveld instelt op Vereist en niet Aanpasbaar Door Gebruiker, kan uw Order-/Offerteformulier onmogelijk worden voltooid. Gelieve te verifiëren dat uw Order-/Offerteformulieren kunnen worden voltooid.',
  orderFieldsEmptyMessage: 'Geen Order-/Offertevelden gedefinieerd.',
  orderFieldsEmptyPrompt: 'Een Order-/Offerteveld toevoegen',
  orderForm: {
    uniqueNameInputHint: 'Voer een unieke naam in voor het nieuwe Formulier.'
  },
  orderFormField: 'Order-/Offerteformulier | Velden Order-/Offerteformulier',
  orderFormLayout: 'Lay-out Order-/Offerteformulier | Lay-outs Order-/Offerteformulier',
  orderFormSetDefault: 'Standaard bestel-/offerteformulier ingesteld',
  orderFormType: 'Bestelformulier',
  orderLayout: 'Lay-out Bestelling | Lay-outs Bestelling',
  orderManagementApprover: 'Bestelbeheer Goedkeurder',
  orderManagementDisable: 'Bestelbeheer Admin Uitschakelen',
  orderManagementViewer: 'Bestelbeheer Bekijker',
  orderNumber: 'Bestelnummer',
  orderQuoteDeleteWarning: 'Velden die zijn toegepast op een bestel- of offerteformulier, die zijn gebruikt in een e-mailsjabloon of die zijn gebruikt in eerder verzonden bestellingen of offertes, kunnen niet worden verwijderd.',
  orderQuoteEmail: 'Bestelling/Offerte e-mail | Bestelling/Offerte e-mails',
  orderQuoteEmailFormat: 'Bestelling/Offerte e-mailindeling | Bestelling/Offerte e-mailindelingen',
  orderQuoteEmailFormatCopyMessage: 'Selecteer een taal voor de nieuwe Bestelling/Offerte e-mailindeling.',
  orderQuoteFetchError: 'Fout bij het verkrijgen van gegevens van Bestel/Offerteformulier',
  orderQuoteForm: 'Bestelling/Offerteformulier | Bestelling/Offerteformulieren',
  orderQuoteFormSaved: 'Order-/Offerteformulier opgeslagen',
  orderQuoteSaveConfirmation: 'Sa uw wijzigingen aan Bestel/Offerteformulier voor een organisatie op?',
  orderQuoteSaveError: 'Fout bij het opslaan van van gegevens van Bestel/Offerteformulier',
  orderStatus: 'Status Order/Offerte | Statussen Order/Offerte',
  orderStatusDeleteMessage: 'Deze status werd gebruikt voor bestellingen en kan niet worden verwijderd.',
  orderSubmittedMessage: 'Succesvol Ingediend',
  orderSuggestion: 'Bestelsuggestie | Bestelsuggesties',
  orderSuggestionEnable: 'Bestelsuggesties Inschakelen',
  orderSuggestionRemovalWarning: 'Het onderdeel zal niet langer worden weergegeven als bestelsuggestie. | De onderdelen zullen niet langer worden weergegeven als bestelsuggesties.',
  orderSuggestionThreshold: 'Bestelsuggestie Drempel',
  orderable: 'Bestelbaar',
  orderableDescription: 'Onderdeel kan worden toegevoegd aan winkelwagen en kan besteld worden',
  orderableLocal: 'Bestelbaar op deze pagina',
  orderableLocalBlocked: 'Onderdeel niet Wereldwijd Bestelbaar',
  ordersLogo: 'Orders Logo',
  ordersMessage: 'Bestelgeschiedenis',
  org: 'Org',
  orgAccessControlsWarning: 'Let op: Bovenliggende organisaties (zoals ouders of grootouders) krijgen automatisch toegang tot content die is toegewezen aan hun onderliggende organisaties (zoals kinderen of kleinkinderen).',
  orgEmailRecipients: 'Org e-mail Ontvangers',
  orgNameOnly: 'Alleen Organisatienaam',
  organization: 'Organisatie | Organisaties',
  organizationAdmin: 'Organisatiebeheer',
  organizationAdminBrowseFlow: 'Een Organisatie kan de standaard browse flow gebruiken, of u kunt deze overschrijven en elke andere browse flow gebruiken.',
  organizationAdminMessage: 'Regelt het gebruikersbeheer en organisatorische instellingen',
  organizationEmailRecipients: 'Organisatie E-mail Ontvangers',
  organizationEmpty: 'Organisatie moet geselecteerd worden',
  organizationEnforceAccessControlsForQuickAdd: 'Toegangscontrole afdwingen voor snel toevoegen',
  organizationKey: 'Organisatiesleutel',
  organizationLibrarySettingsDescription: 'Deze instellingen beheren verschillende Bibliotheekelementen en opties op Organisatieniveau. Wees voorzichtig bij het aanbrengen van wijzigingen. Contacteer Documoto Services voor meer info.',
  organizationMoveToRoot: 'Sleep naar hier om naar hoofdmap te verplaatsen',
  organizationName: 'Naam van de organisatie',
  organizationRearrange: 'Organisaties Herschikken',
  organizationRearrangeDescription: 'De ouder-kind Organisatorische structuur bepaalt verschillende overneembare eigenschappen van een Organisatie zoals Printinstellingen, Stijlen en anderen. Sleep Organisaties om de gewenste hiërarchie weer te geven.',
  organizationReportSettingsSuccessMessage: 'Rapportinstellingen opgeslagen',
  organizationSelect: 'Organisatie Selecteren',
  organizationTags: 'Organisatietags',
  organizationsEmpty: 'Zo te zien heeft u nog geen organisaties aangemaakt',
  orientation: 'Oriëntatie',
  other: 'Andere',
  otherSettings: 'Andere Instellingen',
  outboundCustomerIdParameter: 'Uitgaand Klant-ID Parameternaam',
  outboundSessionIdParameter: 'Uitgaand Sessie-ID Parameternaam',
  outlineMode: 'Uitlijnmodus (Shift O)',
  output: 'Uitvoer',
  outputCatalog: 'Uitvoercatalogus',
  outputDefinition: 'Uitvoerdefinitie | Uitvoerdefinities',
  outputDefinitionDeleted: 'Uitvoerdefinitie verwijderd',
  outputDefinitionSaved: 'Uitvoerdefinitie opgeslagen',
  outputDestination: 'Uitvoerbestemming',
  outputFileName: 'Naam uitvoerbestand',
  outputName: 'Uitvoernaam',
  outputSpecification: 'Uitvoerspecificatie',
  outputSubType: 'Uitvoersubtype',
  outputType: 'Uitvoertype',
  overridden: 'Overschreven',
  overriddenByOrg: 'Overschreven door Org',
  override: 'Overschrijven',
  overrideBrowseFlow: 'Browse Flow Overschrijven',
  overrideFacetLimitValue: 'Overschrijven waarde van facetlimiet',
  overrideFontSettings: 'Lettertypinstellingen Overschrijven',
  overrideHotpointScale: 'Hotpointschaal Overschrijven',
  overrideOrderForm: 'Bestelformulier overschrijven',
  overridePdfNamingStandard: 'Norm voor PDF-benaming negeren',
  overridePrintSettings: 'Printinstellingen Orschrijven',
  overrideQuoteForm: 'Offerteformulier overschrijven',
  overrideSvgOpacity: 'SVG-Lichtdichtheid Overschrijven',
  overrideWarning: 'Het importeren van gegevens vervangt uw huidige BOM-lijst',
  owner: 'Eigenaar | Eigenaars',
  page: 'Pagina | Pagina\'s',
  pageBomPartsDeleted: '{count} onderdelen op pagina BOM zullen niet langer toegankelijk zijn via {filename}.',
  pageBuilder: 'Paginabouwer',
  pageBulkErrorTooManyBooks: 'Beperk het geselecteerde aantal boeken tot niet meer dan 1000',
  pageBulkInsertBooksConfirmInsertAfter: 'Dit zal {replacement} na {original} in {whereUsedBookCount} {bookUnits} invoegen.',
  pageBulkInsertBooksConfirmInsertBefore: 'Dit zal {replacement} voor {original} in {whereUsedBookCount} {bookUnits} invoegen.',
  pageBulkInsertBooksConfirmInsertReplace: 'Dit zal {replacement} invoegen en {original} verwijderen in {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertConfirmInsertAfter: 'Dit zal {replacement} na {original} in {whereUsedBookCount} {bookUnits} en {whereUsedTemplateCount} {templateUnits} invoegen.',
  pageBulkInsertConfirmInsertBefore: 'Dit zal {replacement} voor {original} in {whereUsedBookCount} {bookUnits} en {whereUsedTemplateCount} {templateUnits} invoegen.',
  pageBulkInsertConfirmInsertReplace: 'Dit zal {replacement} invoegen en {original} verwijderen in {whereUsedBookCount} {bookUnits} en {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmTitle: 'Wilt u bulk invoegen voltooien?',
  pageBulkInsertDiscard: 'Uw bulk invoegen zal niet verwerkt worden.',
  pageBulkInsertHelpText: 'Met deze functie kunt u deze bronpagina {thisDisplayName} invoegen in geselecteerde delen van boeken waar er reeds een andere pagina {originalDisplayName} bestaat. U kunt ook optioneel {originalDisplayName} verwijderen van deze boeken.',
  pageBulkInsertInsertAfter: '{replacement} Invoegen NA {original}',
  pageBulkInsertInsertBefore: '{replacement} Invoegen VOOR {original}',
  pageBulkInsertInsertReplace: '{replacement} Invoegen en {original} VERWIJDEREN',
  pageBulkInsertScopeAll: 'Alle {type} die de doelpagina {originalDisplayName} hebben ({whereUsedCount} {units})',
  pageBulkInsertScopeNone: 'Geen van de {type} die de doelpagina {originalDisplayName} hebben',
  pageBulkInsertScopeSome: 'Enkele van de {type} die de doelpagina {originalDisplayName} hebben',
  pageBulkInsertStep1: 'Stap 1: Zoek een gewenste doelpagina',
  pageBulkInsertStep2: 'Stap 2: Bepaal hoe de pagina’s in te voegen of te vervangen',
  pageBulkInsertStep3: 'Stap 3: kies de boeken in welke u de bulk invoegen wenst te verwerken',
  pageBulkInsertStep4: 'Stap 4: Kies de sjablonen waarmee u het invoegen in bulk wil verwerken.',
  pageBulkInsertSuccessBody: 'Wijzigingen inhoudspagina boek zullen onmiddellijk gemaakt worden. Zoekresultaten zullen weergegeven worden van zodra indexering voltooid is.',
  pageBulkInsertSuccessTitle: 'Opdracht bulk invoegen ingediend',
  pageBulkInsertTemplatesConfirmInsertAfter: 'Dit zal {replacement} na {original} in {whereUsedTemplateCount} {templateUnits} invoegen.',
  pageBulkInsertTemplatesConfirmInsertBefore: 'Dit zal {replacement} voor {original} in {whereUsedTemplateCount} {templateUnits} invoegen.',
  pageBulkInsertTemplatesConfirmInsertReplace: 'Dit zal {replacement} invoegen en {original} verwijderen in {whereUsedTemplateCount} {templateUnits}.',
  pageComposer: 'Page Composer',
  pageCreated: 'Pagina Aangemaakt',
  pageDeleteMessage: 'Verwijderde pagina´s zijn onmiddellijk van kracht in Library en Content Admin. De verwijderde pagina kan nog gezocht worden tot een paar minuten later het herindexeren heeft plaatsgevonden.',
  pageDeleteMessage2: 'Deze actie kan niet ongedaan worden gemaakt zonder hulp van Documoto Support. Na 90 dagen worden het verwijderde record en alle koppelingen definitief verwijderd.',
  pageDescription: 'Paginabeschrijving',
  pageDraftsDeleted: 'Conceptpagina´s die aan deze pagina zijn gekoppeld, worden permanent verwijderd.',
  pageFile: 'Paginabestand',
  pageFileRequired: 'Een paging file is vereist.',
  pageFilename: 'Bestandsnaam van pagina',
  pageFilenameDeleted: '{filename} wordt verwijderd.',
  pageFit: 'Pagina Passend',
  pageHeader: 'Koptekst Pagina',
  pageLabel: 'Pagina | Pagina`s',
  pageLayout: 'Paginalay-out',
  pageName: 'Paginanaam',
  pagePart: 'Pagina-onderdeel | Pagina-onderdelen',
  pagePartData: 'Gegevens pagina-onderdeel',
  pagePartLevelDetails: 'Pagina onderdeel bestelbaar/zichtbaar, pagina onderdeellabels',
  pagePartNumberVisible: 'Pagina onderdeelnummer zichtbaar',
  pagePartOrderable: 'Pagina onderdeel bestelbaar',
  pagePartOrderableDescription: 'Onderdeel bestelbaar vanaf deze pagina',
  pagePartTag: 'Pagina Onderdeellabel | Pagina Onderdeellabels',
  pagePartVisibleDescription: 'Onderdeelnummer zichtbaar op deze pagina',
  pageToPartCollectionFailure: 'Toevoegen van Pagina {name} als Onderdeelcollectie mislukt.',
  pageUpdated: 'Pagina Bijgewerkt',
  pageUsageDataCouldNotBeLoaded: 'Gegevens over paginagebruik konden niet worden geladen',
  pageViewer: 'Paginaweergave',
  pageWidth: 'Paginabreedte',
  pagesWhereUsed: 'Pagina’s Waar Gebruikt',
  parentName: 'Oudernaam | Oudernamen',
  part: 'Onderdeel | Onderdelen',
  partCode: 'Onderdeelcode | Onderdeelcodes',
  partCodeAddError: 'Kan Onderdeelcode(`s) Niet Toevoegen',
  partCodeErrorEmpty: 'Kon niet opslaan: Onderdeelcode mag niet leeg zijn',
  partCodeErrorInUse: 'Deze onderdeelcode wordt gebruikt door onderdelen in Documoto en mag niet verwijderd worden. Contacteer Documoto Support via support{\'@\'}documoto.com voor hulp.',
  partCodeErrorNotFound: 'Deze onderdeelcodes konden niet verwijderd worden omdat ze niet gevonden konden worden, zorg ervoor dat alle wijzigingen worden opgeslagen.',
  partCodesManager: 'Onderdeelcodes Beheerder',
  partCodesMessage: 'Onderdeelcodes kunnen worden gebruikt in plaats van onderdeelnummers en worden vaak gebruikt om aan te geven wanneer Stuklijstitems verouderd zijn, niet beschikbaar zijn of alleen referentieartikelen zijn (bijv. \'PNNA\', \'-\', \'REF\').',
  partCollection: 'Onderdeelcollectie | Onderdeelcollecties',
  partCollectionsDescription: 'Voeg tot 20 {parts} {pages} om als {collections} weer te geven op deze {productPage}.',
  partCollectionsDescription2: 'De geselecteerde {collections} definiëren welke {parts} beschikbaar zullen zijn voor eindgebruikers voor snelle toegang of bestellen.',
  partCollectionsDescription3: 'De volgorde gedefinieerd onder de bediening is de manier waarop ze verschijnen in de Bibliotheek {productPage} Weergave.',
  partCollectionsLimitError: 'Maximum van {limit} {item1} is toegestaan per {item2}.',
  partCreated: 'Onderdeel Aangemaakt',
  partData: 'Onderdeelgegevens',
  partDebouncerEmailQueueJob: 'E-mailwachtrij',
  partDescription: 'Onderdeelbeschrijving',
  partEquipmentVerificationBanner: 'Banner voor verificatie van onderdeel voor apparatuur',
  partLabel: 'Onderdeel | Onderdelen',
  partLevelDetails: 'Onderdeelprijzen, bestelbaar/zichtbaar, extra vertalingen, onderdeellabels',
  partName: 'Onderdeelnaam',
  partNumber: 'Onderdeelnummer',
  partNumberCopied: '{label} gekopieerd naar klembord',
  partNumberDescription: 'Het interne onderdeelnummer voor eindgebruikers om te zoeken',
  partNumberSupercededBy: '{partNumber} bestaat als een SupersededPartNumber tag op...',
  partNumberVisible: 'Onderdeelnummer Zichtbaar',
  partNumberVisibleDescription: 'Onderdeelnummer is zichtbaar voor eindgebruikers',
  partNumberVisibleLocal: 'Zichtbaar op deze pagina',
  partNumberVisibleLocalBlocked: 'Onderdeelnummer is niet Wereldwijd Zichtbaar',
  partOrderable: 'Onderdeel bestelbaar',
  partRequired: 'Tenminste één onderdeel is vereist',
  partTag: 'Pagina Label | Pagina Labels',
  partTagProperty: 'Onderdeeltag Eigenschap| Onderdeeltag Eigenschappen',
  partUpdated: 'Onderdeel bijgewerkt',
  partVerificationInstructions: 'Controleer of dit onderdeel past voor uw apparatuur',
  partialSupport: 'Gedeeltelijke Ondersteuning',
  partnerApiKey: 'Partner API Key',
  partnerRESTRequestLimit: 'Partner REST aanvraaglimiet',
  partsBook: 'Onderdelenboeken | Onderdelenboeken',
  partsBulkImport: {
    description: 'Upload je gegevensbestand om onderdelen in bulk te importeren. Ondersteund bestandsformaat: XSLX.',
    downloadTemplate: 'XSLX-sjabloon downloaden',
    downloadUnprocessedRows: 'Spreadsheet met onverwerkte rijen downloaden',
    hideRequirements: 'XSLX-vereisten verbergen',
    overwriteTagValues: 'Labelwaarden voor overeenkomende tags overschrijven',
    overwriteTranslations: 'Overeenkomende vertalingen overschrijven',
    requirements: {
      discountPrice: {
        description: 'Stelt de kortingsprijs op tenantniveau in.'
      },
      enUSDescription: {
        description: 'Taalspecifieke vertaalde beschrijving voor een onderdeel. Zie onze <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Taalondersteuningsgids</a>.'
      },
      enUSName: {
        description: 'Taalspecifieke vertaalde naam voor een onderdeel. Tenminste één vertaling is vereist voor nieuwe onderdelen. Zie onze <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Taalondersteuningsgids</a>.'
      },
      orderable: {
        description: 'Bepaalt of het onderdeel kan worden besteld. Toegestane waarden zijn \'waar\' of \'onwaar\'. Standaard ingesteld op \'waar\'.'
      },
      orgDiscountPrice: {
        description: 'Stelt de kortingsprijs op organisatieniveau voor een bepaalde organisatie in. Voorbeeld van een koptekst: `<OrganizationName> / Discount Price`'
      },
      orgRetailPrice: {
        description: 'Stelt de verkoopprijs op organisatieniveau voor een bepaalde organisatie in. Voorbeeld van een koptekst: `<OrganizationName> / Retail Price`'
      },
      orgWholesalePrice: {
        description: 'Stelt de groothandelsprijs op organisatieniveau voor een bepaalde organisatie in. Voorbeeld van een koptekst: `<OrganizationName> / Wholesale Price`'
      },
      partNumber: {
        description: 'Een unieke identificatie voor het onderdeel.'
      },
      retailPrice: {
        description: 'Stelt de verkoopprijs op tenantniveau in.'
      },
      supplier: {
        description: 'De naam van de leverancier van het onderdeel.'
      },
      tagInternalName: {
        description: 'Hiermee worden tags toegewezen aan het onderdeel. De koptekst moet de interne naam van de tag zijn. Gebruik een &#124; als scheidingsteken voor meerdere waarden. Voorbeeld: Rood&#124;Groen&#124;Blauw.'
      },
      thumbnail: {
        description: 'Miniatuurbestandsnaam. Toegestane extensies: .png, .jpg, .jpeg, .gif'
      },
      uom: {
        description: 'Meeteenheid (bv. "elke", "eenheid").'
      },
      visible: {
        description: 'Bepaalt of het onderdeel zichtbaar is. Toegestane waarden zijn \'waar\' of \'onwaar\'. Standaard ingesteld op \'waar\'.'
      },
      wholesalePrice: {
        description: 'Stelt de groothandelsprijs op tenantniveau in.'
      }
    },
    showRequirements: 'XSLX-vereisten weergeven',
    submitNote: 'Door te klikken op "Verzenden" zal een achtergrondopdracht starten en de pagina "Job Manager” openen.',
    success: 'Bulkimportopdracht voor onderdelen aangemaakt',
    title: 'Onderdelen importeren in bulk'
  },
  partsColumns: 'Onderdelenkolommen',
  partsDisplay: 'Onderdeelweergave',
  partsList: 'Onderdelenlijst',
  partsListColumn: 'Onderdelenlijst Kolom | Onderdelenlijst Kolommen',
  partsListData: 'Gegevens Onderdelenlijst',
  partsListGridHeader: 'Rasterkoptekst Onderdelenlijst',
  partsNotSelected: 'Standaard afbeelding gebruikt voor onderdeel-miniaturen. Indien een standaard miniatuur niet wordt toegepast, zal Documoto een standaard automatische miniatuur weergeven.',
  partsPage: 'Onderdelenpagina | Onderdelenpagina’s',
  partsPageGroup: {
    columnsLoadErrorMsg: 'Kon onderdelenkolommen niet laden',
    columnsUpdateErrorMsg: 'Er is een fout opgetreden bij het bijwerken van de Onderdelenkolommen',
    columnsUpdateSuccessMsg: 'Onderdelenkolommen bijgewerkt',
    cropWhitespaceOnImages: 'Witruimte bijsnijden op afbeeldingen',
    excludePartCodesFromPartsLists: 'Onderdeelcodes uit Onderdelenlijsten Verwijderen',
    highlightAlternateRows: 'Afwisselende Rijen Markeren',
    keepBOMOnRight: 'Stuklijst Rechts Houden',
    keepImagesOnLeft: 'Afbeeldingen Links Houden',
    printBorderAroundImages: 'Printrand Rond Afbeeldingen',
    printHotpointsOnImages: 'Hotpoints afdrukken op afbeeldingen',
    rotateImagesAutomatically: 'Afbeeldingen Automatisch Roteren'
  },
  partsPages: 'Onderdelenpagina’s',
  password: 'Wachtwoord',
  passwordBlankMessage: 'Wachtwoord mag niet blanco zijn',
  passwordCannotBeSame: 'Mag niet hetzelfde zijn als uw huidige wachtwoord',
  passwordCasingMassage: 'Moet tenminste één kleine letter en één hoofdletter bevatten',
  passwordCriteriaInfo: 'Uw nieuw wachtwoord moet voldoen aan de volgende criteria:',
  passwordExpiredHeader: 'Wachtwoord is verlopen',
  passwordExpiredInfo: 'Uw wachtwoord is verlopen. Uw nieuw wachtwoord moet voldoen aan de volgende criteria:',
  passwordLowerCaseMessage: 'Wachtwoord moet tenminste één kleine letter bevatten',
  passwordMinLengthMessage: 'Wachtwoorden moeten minstens 8 karakters lang zijn',
  passwordNotMatchingMessage: 'Wachtwoorden zijn niet hetzelfde',
  passwordOptions: 'Wachtwoordopties',
  passwordOptionsRequired: 'Wachtwoordopties mag niet leeg zijn',
  passwordSpecialCharactersMessage: 'Wachtwoord moet tenminste één speciaal teken bevatten',
  passwordUpperCaseMessage: 'Wachtwoord moet tenminste één hoofdletter bevatten',
  passwordWillExpire1Day: 'Het wachtwoord om aan te melden verloopt in minder dan 1 dag',
  passwordWillExpire5Days: 'Het wachtwoord om aan te melden verloopt in minder dan 5 dagen',
  passwordsMatch: 'Wachtwoorden komen overeen',
  pdfImport: {
    aiPdfImports: 'PDF import via AI',
    aiPdfImportsDescription: 'Beheer PDF import via AI voor automatische contentverwerking.',
    createImport: 'Nieuwe PDF import via AI',
    createImportDescription: 'Selecteer een PDF-bronbestand en configureer de instellingen voor het extraheren. Bestandsbeperkingen: maximaal 500 MB en tot 3000 pagina\'s.',
    defaultPartNumberCode: 'Standaard code voor onderdeelnummer',
    defaultTranslationLocale: 'Standaard locatie voor vertaling',
    defaultUomHelpText: 'Wordt gebruikt wanneer een kolom \'Meeteenheid\' niet is toegewezen of wanneer een geëxtraheerde stuklijstregel geen waarde bevat voor de meeteenheid.',
    defaultUomRequired: 'Vereist tenzij UOM is verstrekt',
    dropFileMessage: 'Zet het bestand hier neer of klik om te uploaden',
    fileSizeError: 'Bestandsgrootte overschrijdt de limiet van 500MB',
    importCreatedError: 'Import aanmaken mislukt.',
    importCreatedSuccess: 'Import succesvol aangemaakt en in de wachtrij gezet voor verwerking',
    mapColumnToTag: 'Kolom toewijzen aan pagina met onderdeeltag',
    monthlyLimitExceeded: 'De maandelijkse limiet voor het importeren van PDF-bestanden via AI is overschreden. Neem contact op met uw Customer Success Manager voor ondersteuning.',
    pageNumberFilterInvalidRange: 'Ongeldig paginanummerbereik',
    pageNumberFilterPlaceholder: 'bv. 6, -7, 8-, 9-20',
    partNumberCodeHelp: 'Code van onderdeelnummer geldt voor stuklijstrijen waar de waarde van onderdeelnummer leeg is.',
    pdfImport: 'PDF import | PDF Imports',
    pdfImportsDescription: 'Beheer AI-aangedreven imports van PDF om automatisch onderdeelgegevens uit PDF-documenten te extraheren.',
    publishModalFooterHelp: 'Door op "Publiceren" te klikken, wordt een opdracht in de achtergrond in de wachtrij geplaatst en gestart. U wordt vervolgens teruggeleid naar de pagina voor het beheer van PDF import via AI, waar u de publicatiestatus kunt opvolgen.',
    publishSkipAutoHotpointing: 'Pagina automatische hotspots overslaan | Pagina\'s automatische hotspots overslaan',
    publishingFinishedNone: 'Publiceren van "{importName}" import voltooid. Er zijn geen pagina\'s gepubliceerd.',
    publishingFinishedPartial: 'Publiceren van "{importName}" import voltooid. {success} pagina gepubliceerd, {failed} pagina mislukt. | Publiceren van {importName} import voltooid. {success} pagina\'s gepubliceerd, {failed} pagina\'s mislukt.',
    publishingFinishedSuccess: 'Publiceren van "{importName}" import voltooid. {count} pagina gepubliceerd. | Publiceren van {importName} import voltooid. {count} pagina\'s gepubliceerd.',
    reviewStatusAll: 'Status: Alle',
    reviewStatusApproved: 'Goedgekeurd',
    reviewStatusDropped: 'Verwijderen',
    reviewStatusNoStatus: 'Geen status',
    reviewStatusNone: 'Geen',
    reviewStatusPending: 'In behandeling',
    selectPagePartTag: 'Selecteer pagina met onderdeeltag',
    statusDeclined: 'Geweigerd',
    statusFailed: 'Mislukt',
    statusPending: 'In behandeling',
    statusProcessing: 'Bezig met verwerken',
    statusPublished: 'Gepubliceerd',
    statusPublishing: 'Bezig met publiceren',
    submitNote: 'Door op "Verzenden" te klikken, wordt een opdracht in de achtergrond in de wachtrij geplaatst en gestart. U wordt vervolgens teruggeleid naar de pagina voor het beheer van PDF import via AI, waar u de importstatus kunt opvolgen.'
  },
  pdfImportBom: {
    columnMatchStatus: 'Overeenkomststatus',
    columnPagePartTag: 'Pagina met onderdeeltag',
    columnPartNameWithLocale: 'Onderdeelnaam ({locale})',
    emptyState: 'Geen stuklijstitems gevonden',
    existingPartNameApplied: 'Bestaande onderdeelgegevens toegepast',
    title: 'Stuklijst'
  },
  pdfImportIllustrations: {
    adjustBoundsButton: 'Illustratiegrenzen aanpassen',
    boundsAdjusted: 'Grenzen aangepast',
    emptyState: 'Geen illustraties voor deze pagina',
    hiresUnavailableError: 'Hoge resolutie afbeelding is niet beschikbaar voor deze pagina.'
  },
  pdfImportOverview: {
    actionApproveSelected: 'Geselecteerde goedkeuren ({count})',
    actionClearStatusSelected: 'Status voor geselecteerde wissen ({count})',
    actionCopySelected: 'Samenvoegen in eerst geselecteerde pagina',
    actionDeleteImport: 'PDF import via AI verwijderen',
    actionDropSelected: 'Geselecteerde verwijderen ({count})',
    actionPendingSelected: 'Stel geselecteerde in op in behandeling ({count})',
    actionPublishSelected: 'Geselecteerde publiceren',
    autoMergeAction: 'Pagina\'s automatisch samenvoegen',
    autoMergeConfirmHelp: '\'Pagina\'s automatisch samenvoegen\' zoekt pagina\'s met dezelfde paginanaam en voegt elke overeenkomende groep samen tot de eerste pagina in de visuele volgorde. Bronpagina\'s die in een doelpagina worden samengevoegd, worden gemarkeerd als \'Verwijderd\'. Controleer de resultaten vooraleer te publiceren.',
    autoMergeConfirmTitle: 'Pagina\'s met overeenkomende namen automatisch samenvoegen?',
    autoMergeFailed: 'Automatisch samenvoegen is mislukt, er zijn geen wijzigingen aangebracht',
    autoMergeSuccess: 'Automatisch samenvoegen is voltooid: {count} groep(en) samengevoegd, {dropped} pagina(\'s) verwijderd',
    composedPageIndicator: 'Deze pagina bevat content die is gekopieerd van andere PDF-pagina\'s.',
    contentTypeAll: 'Alle contenttypes',
    contentTypeBomOnly: 'Alleen stuklijst',
    contentTypeBoth: 'Zowel stuklijst als illustraties',
    contentTypeEmpty: 'Pagina’s leegmaken',
    contentTypeFilterLabel: 'Contenttype',
    contentTypeIllustrationsOnly: 'Alleen illustraties',
    importSettings: 'Instellingen importeren',
    includeDroppedPagesLabel: 'Verwijderede pagina\'s opnemen',
    incompleteBomFilterLabel: 'Pagina\'s met onvolledige stuklijst tonen',
    mergeConfirmSourcePages: '{count} bronpagina geselecteerd: | {count} bronpagina\'s geselecteerd:',
    mergeConfirmTitle: 'Voeg geselecteerde pagina\'s samen met de eerst geselecteerde pagina?',
    mergeConfirmTarget: 'Doelpagina: {pageLabel}',
    mergeFailed: 'Samenvoegen van geselecteerde pagina\'s met de eerst geselecteerde pagina mislukt',
    mergeSuccess: 'Pagina\'s samengevoegd in {pageLabel} ({bomCount} stuklijstitems, {illustrationCount} illustraties)',
    noPages: 'Geen pagina(\'s) beschikbaar',
    noPagesHint: 'Deze import bevat geen pagina(\'s)',
    noResults: 'Geen overeenkomende pagina\'s gevonden',
    noResultsHint: 'Probeer uw zoekopdracht of filters aan te passen',
    notificationLoadFailed: 'Overzicht kon niet worden geladen',
    notificationReviewStatusUpdated: '{count} pagina(\'s) succesvol bijgewerkt',
    notificationSelectAllFailed: 'Selecteren van alle pagina\'s mislukt',
    notificationUpdateReviewStatusFailed: 'Bijwerken van beoordelingsstatus mislukt',
    publishBookIdentifierNotUnique: 'Boekidentificator moet uniek zijn.',
    publishBookIdentifierTakenHelp: 'Een boek met deze identificator bestaat al.',
    publishFailed: 'Publiceren van geselecteerde pagina(\'s) mislukt',
    publishModalTitle: 'Geselecteerde pagina\'s publiceren',
    publishNewBookHelpText: 'Succesvol gepubliceerde pagina\'s worden in dezelfde volgorde aan het nieuwe boek toegevoegd als ze verschijnen in het overzicht van PDF import via AI. Er wordt alleen een nieuw boek aangemaakt als ten minste één geselecteerde pagina succesvol wordt gepubliceerd.',
    publishNewBookIdentifierLabel: 'Boekidentificator',
    publishOptionNewBook: 'Maak een nieuw boek en voeg er pagina\'s aan toe',
    publishOptionPagesOnly: 'Alleen pagina\'s publiceren',
    reviewManagement: 'Beheer van beoordelingen',
    reviewManagementTooltip: 'Gebruik de beoordelingsstatussen om uw werk te organiseren tijdens het beoordelen van de geëxtraheerde inhoud. Goedgekeurd, In behandeling en Verwijderd hebben geen invloed op de publicatie. Ze dienen alleen om de voortgang van de beoordeling op te volgen.',
    reviewProgress: 'Voortgang van beoordelingen',
    title: 'Overzicht'
  },
  pdfImportPageDetails: {
    actionPublish: 'Pagina publiceren',
    firstPage: 'Eerste pagina',
    lastPage: 'Laatste pagina',
    matchingPageNewPage: 'Nieuwe onderdelenpagina',
    matchingPageNewPageSharedSvg: 'Nieuwe onderdelenpagina, maar het SVG-bestand wordt gedeeld met andere pagina(\'s)',
    matchingPageOpenExisting: 'Bestaande pagina openen',
    matchingPageOverwrite: 'Bestaande onderdelenpagina wordt overschreven',
    navLabel: 'Overzicht van PDF import via AI',
    navigationFailedText: 'Navigeren naar pagina {pageNumber} mislukt',
    nextPage: 'Volgende pagina',
    notificationLoadFailed: 'Pagina laden mislukt',
    notificationPublishFailed: 'Verzenden van opdracht om te publiceren mislukt',
    notificationSaveFailed: 'Opslaan van pagina mislukt',
    notificationSaveSuccess: 'Pagina succesvol opgeslagen.',
    pageOriginComposed: 'Samengesteld uit meerdere PDF-pagina\'s',
    pageOriginExtracted: 'Geëxtraheerd uit één PDF-pagina',
    pageOriginLabel: 'Oorsprong van pagina',
    previousPage: 'Vorige pagina',
    publishPageModalHelpText: 'Deze onderdelenpagina wordt zonder context van een boek gepubliceerd. Bij publicatie wordt een nieuwe onderdelenpagina aangemaakt of een bestaande pagina overschreven al naargelang de identiteitsregels van de pagina.',
    thumbnailCardTitle: 'Miniatuur van PDF pagina',
    viewBom: 'Stuklijst'
  },
  pdfImportPublishingHistory: {
    bookResultCreated: 'Aangemaakt',
    columnPdfPage: 'PDF-pagina(\'s)',
    columnPublishingStatus: 'Publicatiestatus',
    detailLoadFailed: 'Laden van de details voor het publiceren van een opdracht mislukt.',
    emptyBookOperations: 'Er zijn geen boekoperaties uitgevoerd in deze opdracht.',
    emptyJobsHint: 'Publicatie-activiteit verschijnen hier nadat pagina\'s zijn gepubliceerd.',
    emptyJobsTitle: 'Er zijn nog geen opdracht(en) uitgevoerd voor deze PDF import via AI.',
    emptyPagesTitle: 'Er zijn geen pagina(\'s) die overeenkomen met het geselecteerde filter.',
    filterAllPages: 'Alle pagina\'s tonen',
    filterFailedOnly: 'Alleen mislukte pagina\'s tonen',
    filterNameQuery: 'Naam of paginabestand',
    filterPublishedOnly: 'Alleen gepubliceerde pagina\'s tonen',
    helpText: 'Deze pagina toont de geschiedenis van de onderdelenpagina\'s die zijn gepubliceerd vanuit deze PDF import via AI, inclusief pagina\'s die zijn aangemaakt, overschreven of waarvan de publicatie is mislukt.',
    jobLabel: 'Opdracht #{number}',
    loadFailed: 'Laden van de publicatiegeschiedenis mislukt',
    resultPublishedCreated: 'Gepubliceerd - Aangemaakt',
    resultPublishedUpdated: 'Gepubliceerd - Overschreven',
    resultSummaryBookCreated: 'Een nieuw boek gemaakt.',
    resultSummaryNone: 'Geen pagina\'s gepubliceerd',
    resultSummaryPagesFailed: '{n} pagina mislukt. | {n} pagina\'s mislukt.',
    resultSummaryPagesPublished: '{n} pagina gepubliceerd. | {n} pagina\'s gepubliceerd.',
    statusFailed: 'Mislukt',
    statusInProgress: 'Bezig',
    title: 'Publicatiegeschiedenis'
  },
  permission: 'Toestemming| Toestemmingen',
  phoneNumber: 'Telefoonnummer',
  phoneNumberExt: 'Ext',
  phonePrimary: 'Primair Telefoonnummer',
  phoneSecondary: 'Secundair Telefoonnummer',
  pinFilter: 'Filter vastmaken aan zoekresultatenpagina',
  pinned: 'Vastgezet',
  plusMoreOrgs: '+ {totalOrgCount} bijkomende Organisaties',
  polishDescription: 'Poolse beschrijving',
  polishName: 'Poolse naam',
  populatePdfNameSelection: 'Selectie van PDF-bestandsnaam opvullen',
  populatePdfNameWith: 'PDF-bestandsnaam opvullen met',
  port: 'Poort',
  portrait: 'Staand',
  portugueseDescription: 'Portugese beschrijving',
  portugueseName: 'Portugese naam',
  postComment: 'Opmerking Posten',
  postalCode: 'Postcode',
  poweredBy: 'Aangedreven door',
  preferences: 'Voorkeuren',
  preferencesDisable: 'Gebruikersvoorkeuren Uitschakelen',
  prefix: 'Prefix | Prefixes',
  preview: 'Voorbeeld',
  previewOfName: 'Voorvertoning van {name}',
  pricing: 'Prijs',
  pricingDiscountEnabled: 'Prijs met Korting Weergeven',
  pricingDisplayInCart: 'Prijzen in Winkelwagen Weergeven',
  pricingDisplayInPartsList: 'Prijzen in Onderdelenlijst Weergeven',
  pricingGlobal: 'Wereldwijde Prijzen',
  pricingGlobalDescription: 'De normale prijs wanner er geen overschrijving van een Organisatie is',
  pricingHideInitially: 'Prijs initieel verbergen',
  pricingHidePricingButton: 'Knop Prijzen Verbergen Inschakelen',
  pricingHidePricingButtonDisable: 'Knop Prijzen Verbergen Uitschakelen',
  pricingHidePricingButtonDisableHelp: 'Door de knop \'Prijzen verbergen\' uit te schakelen, kunnen gebruikers geen prijsniveaus meer weergeven/verbergen. Elk prijsniveau dat is ingesteld op "Prijs initieel verbergen" blijft verborgen en gebruikers kunnen het niet meer weergegeven.',
  pricingOrganization: 'Organisatieprijzen',
  pricingOrganizationDeleteConfirm: 'Weet u zeker dat u deze Organisatieprijzen wilt verwijderen?',
  pricingOrganizationDescription: 'Organisatieprijzen overschrijven de wereldwijde prijzen voor alle gebruikers binnen een Organisatie en de Kinderorganisaties.',
  pricingOrganizationDuplicate: 'Deze organisatie werd reeds overschreven',
  pricingOrganizationEmptyState: 'Geen organisatie-overschrijvingen bepaald. Klik op {add} om te starten.',
  pricingRetailEnabled: 'Retailprijs Weergeven',
  pricingWholesaleEnabled: 'Groothandelprijs Weergeven',
  primary: 'Primair',
  print: 'Afdrukken',
  printJob: 'Taak Afdrukken',
  printLogo: 'Logo afdrukken',
  printSetting: 'Printinstelling',
  printSettingCopyMessage: 'Voer een unieke naam in voor de nieuwe Printinstelling.',
  printSettingCreated: 'Printinstellingen aangemaakt',
  printSettingDeleteFail: 'Kon Printinstelling Niet Annuleren',
  printSettingEmptyMessage: 'Geen Printinstelling bepaald. Voeg een Printinstelling toe om te starten',
  printSettingSaveFail: 'Kon Printinstelling Niet Opslaan',
  printSettingSelectionRequired: 'Selectie voor afdrukinstelling vereist.',
  printSettingSetDefaultSuccess: 'Standaard Printinstelling Ingesteld',
  printSettingUpdateFail: 'Kon Printinstelling Niet Bijwerken',
  printSettings: 'Printinstellingen',
  printSettingsLogo: 'Printinstellingen Logo',
  printerLane: 'Printerstrook',
  printing: 'Bezig Met Afdrukken',
  printingDisabled: 'Alles Afdrukken Uitschakelen',
  privacyPolicy: 'Privacybeleid',
  proceed: 'Doorgaan',
  process: 'Verwerken',
  processContent: 'Verwerk Content',
  processToDraft: 'Proces naar concept',
  processedPlzToDraft: 'Verwerkte PLZ(s) naar Concept(en)',
  processing: 'Bezig met verwerken',
  productCategory: 'Productcategorie | Productcategorieën',
  productCategoryName: 'Productcategorienaam',
  productId: 'Product-ID',
  productIdErrorMessage: 'Er is een product-ID vereist',
  productIdMessage: 'De identificator die gebruikers gebruiken om het product te vinden, bv. \'FTX1000\'',
  productPage: 'Productpagina | Productpagina\'s',
  productPageAccessControlDescription: 'Toegangscontroles bepalen wie deze pagina kan zien, op basis van toewijzingen van Organisaties en Gebruikersgroepen.',
  productPageCreated: 'Productpagina aangemaakt',
  productPageDescription: 'Productpaginabeschrijving',
  productPageIdentifierMessage: 'Een unieke interne identificator voor deze pagina',
  productPageName: 'Productpaginanaam',
  productPageProductId: 'Productpagina product-ID',
  productPageUpdated: 'Productpagina Bijgewerkt',
  productPagesBulkImport: {
    description: 'Upload je gegevensbestand om productpagina\'s in bulk te importeren. Ondersteund bestandsformaat: XLSX.',
    downloadUnprocessedRows: 'Rekenblad met onverwerkte rijen downloaden',
    overwriteAccessControls: 'Toegangscontroles overschrijven (Organisaties en gebruikersgroepen)',
    overwriteAssociatedMedia: 'Verwante media overschrijven',
    requirements: {
      enUSCategory: {
        description: 'Bestaande naam van productcategorie van een bepaalde locatie. Zie onze <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Taalondersteuningsgids</a>.'
      },
      enUSDescription: {
        description: 'Taalspecifieke vertaalde beschrijving voor een productpagina. Zie onze <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Taalondersteuningsgids</a>.'
      },
      enUSName: {
        description: 'Taalspecifieke vertaalde naam voor een productpagina. Tenminste één vertaling is vereist voor nieuwe productpagina\'s. Zie onze <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Taalondersteuningsgids</a>.'
      },
      identifier: {
        description: 'Een unieke identificatiecode voor een productpagina, die alleen zichtbaar en doorzoekbaar is in het beheercentrum.'
      },
      media: {
        description: 'Lijst met media-identificatoren die gerelateerd zijn aan een bepaalde productpagina. Gebruik een &124-scheidingsteken voor meerdere waarden.'
      },
      organizations: {
        description: 'Lijst met organisaties met toegang tot een bepaalde productpagina. Gebruik een &124-scheidingsteken voor meerdere waarden.'
      },
      productId: {
        description: 'Een identificator voor een productpagina voor eindgebruikers, te bekijken en te doorzoeken in de Bibliotheek. Product-ID hoeft geen unieke waarde te zijn.'
      },
      tagInternalName: {
        description: 'Wijst tags toe aan een productpagina. De koptekst moet de interne naam van de tag zijn. Gebruik een &#124; als scheidingsteken voor meerdere waarden. Voorbeeld: Rood &#124; Groen&#124; Blauw.'
      },
      thumbnail: {
        description: 'Miniatuurbestandsnaam. Toegestane extensies: .png, .jpg, .jpeg, .gif'
      },
      userGroups: {
        description: 'Lijst met gebruikersgroepen met toegang tot een bepaalde productpagina. Gebruik een &124-scheidingsteken voor meerdere waarden.'
      }
    },
    success: 'Bulkimportopdracht voor productpagina\'s aangemaakt',
    title: 'Bulkimport van productpagina\'s'
  },
  production: 'Productie',
  professional: 'Professioneel',
  profile: 'Profiel',
  prohibitExportDownloadOfContent: 'Exporteren/Downloaden van content verbieden',
  prohibitExportDownloadOfContentHelpText: 'De instelling op \'Enable\' zal voorkomen dat een gebruiker (met machtigingen) deze inhoud kan exporteren of downloaden.',
  property: 'Eigenschap | Eigenschappen',
  province: 'Provincie',
  'public': 'Publiek',
  publish: 'Publiceren',
  publishDocuments: 'Documenten publiceren',
  publishDraft: 'Concept publiceren',
  publishThumbnailJob: 'Miniatuur publiceren',
  publisher: 'Uitgever| Uitgevers',
  publisherJob: 'Taak van Uitgever',
  publisherLane: 'Publicatiestrook',
  publisherManualLane: 'Handmatige publicatiestrook',
  publisherMessage: 'Contentcreatie, beheer en printinstellingen',
  publishingErrors: 'Publicatiefouten',
  publishingErrorsWithName: 'Fouten {name} publiceren',
  publishingInProgress: 'Bezig met publiceren, kan niet indienen',
  purchaseOrder: 'Inkooporder',
  purchaseOrderTemplateDisabled: 'Bestelsjablonen Uitschakelen',
  purchaseOrderTemplateEnabled: 'Bestelsjablonen Inschakelen',
  qty: 'Aantal',
  quantity: 'Aantal',
  query: 'Zoekopdracht',
  quickAdd: 'Snel Toevoegen',
  quickAddHelpText: 'Begin te typen om onderdelen te vinden om aan het winkelmandje toe te voegen.',
  quickAddInCartEnabled: 'Snel in Winkelwagen Toevoegen Inschakelen',
  quickLinks: 'Snelle Links',
  quote: 'Quote | Quotes',
  quoteFormType: 'Offerteformulier',
  quoteTemplateDisabled: 'Offertesjablonen Uitschakelen',
  quoteTemplateEnabled: 'Offertesjablonen Inschakelen',
  range: 'Bereik',
  rearrange: 'Herschikken',
  rebuildIndexJob: 'Index opnieuw bouwen',
  recentSearches: 'Recent zoekopdrachten',
  recentlyAdded: 'Onlangs Toegevoegd',
  recentlyEdited: 'Recent Bijgewerkt',
  recentlyViewed: 'Onlangs Bekeken',
  recipientOrRecipients: 'Ontvanger(s)',
  rectangle: 'Rechthoek',
  redirect: 'Omleiden',
  refresh: 'Vernieuwen',
  related: 'Gerelateerd',
  relatedDescription: 'Gerelateerde media die bestaan in de bibliotheek voor dit {type}. Opmerking: gerelateerde media moet toegangscontroles ingeschakeld hebben voor gebruikers om te zien in het tabblad \'Gerelateerd\'',
  relatedInfo: 'Gerelateerde Info',
  relatedView: 'Gerelateerde Media Weergeven',
  relationship: 'Relatie | Relaties',
  releaseNotes: 'Uitgaveopmerkingen',
  remainingWidth: 'Resterende Breedte',
  rememberMe: 'Onthoud Mij',
  remove: 'Verwijderen',
  removeAll: 'Alles Verwijderen',
  removeItemConfirmation: 'Weet u zeker dat u {item} wilt verwijderen?',
  removeItemCount: 'Weet u zeker dat u {count} {type} wil verwijderen?',
  replace: 'Vervangen',
  replaceExisting: 'Bestaande Vervangen',
  report: 'Rapport | Rapporten',
  reportAnIssue: 'Een probleem Melden',
  reportAnIssueMessage: 'E-mail succesvol verzonden.',
  reportCatalogName: 'Naam van rapportcatalogus',
  reportCatalogNotSet: 'Rapportcatalogus is niet gedefinieerd voor het rapport.',
  reportDefinition: 'Rapportdefinitie | Rapportdefinities ',
  reportDefinitionDeleteError: 'Rapportdefinitie kon niet verwijderd worden',
  reportExportTimeWarning: 'Afhankelijk van het aantal records en de geselecteerde indeling kan het exporteren enkele minuten duren om te voltooien.',
  reportSettings: 'Rapportinstellingen',
  reporting: 'Verslaglegging',
  reportingMessage: 'Toegang tot verschillende rapporten en maatstaven',
  reportsEmptyState: 'Geen rapporten',
  reportsLibrary: 'Rapportbibliotheek',
  requestForQuote: 'Verzoek om Offerte',
  requestFormType: 'Offerteformulier',
  requireAuthentication: 'Authenticatie Vereist',
  required: 'Vereist',
  requiredField: 'Veld Vereist',
  requiredItem: '{item} is vereist',
  requiredMessage: 'Er is een {item} vereist',
  requiredMessageAndUnique: 'Een {item} is vereist en moet uniek zijn.',
  requiredReading: 'Verplicht Te Lezen Tekst',
  requiredReadingMessage: 'Controleer het volgende:  ',
  requiredType: 'Er is een type vereist',
  requiredUrlMessage: 'Er is een correcte URL vereist.',
  reset: 'Opnieuw Instellen',
  resetPassword: 'Wachtwoord Opnieuw Instellen',
  resetPasswordError: 'Er was een probleem met het opnieuw instellen van uw wachtwoord, probeer het opnieuw.',
  resetPasswordTokenError: 'Token om wachtwoord te herstellen is ongeldig.',
  resetZoom: 'Zoom opnieuw instellen',
  resize: 'Formaat wijzigen',
  resizeThumbnails: 'Automatisch verkleinen/vergroten van miniaturen',
  resource: 'Bron | Bronnen',
  result: 'Resultaat | Resultaten',
  resultFor: 'Resultaat voor {item} | Resultaten voor {item}',
  retail: 'Retail',
  retailPrice: 'Retailprijs',
  retailTotal: 'Totaal van Retail',
  'return': 'Retourneren',
  returnToItem: 'Terugkeren naar {item}',
  returnToMedia: 'Terugkeren naar Media',
  returnToPartList: 'Terugkeren naar Onderdelenlijst',
  returnToTemplate: 'Terugkeren naar Template',
  returnToViewer: 'Terugkeren naar Viewer',
  revert: 'Ongedaan maken',
  revertChanges: 'Wijzigingen Ongedaan Maken',
  revertChangesMsg: 'Weet u zeker dat u uw wijzigingen ongedaan wil maken?',
  right: 'Rechts',
  romanianDescription: 'Roemeense beschrijving',
  romanianName: 'Roemeense naam',
  rootLevelBrowseFlow: 'Hoofdniveau',
  row: 'Rij',
  russianDescription: 'Russische beschrijving',
  russianName: 'Russische naam',
  s3DataExportsEnabled: 'S3-gegevensexports inschakelen',
  sampleData: 'Voorbeeldgegevens',
  samplePreview: 'Voorbeeld',
  sandbox: 'Zandbak',
  sat: 'Zat',
  save: 'Opslaan',
  saveAndClose: 'Opslaan en sluiten',
  saveAndEditTarget: 'Opslaan en doel bewerken',
  saveChanges: 'Wijzigingen opslaan voor {item}? {name}',
  saveChangesToItem: 'Wijzigingen opslaan voor dit {item}?',
  saveNewAPIKey: 'Nieuwe Integratiesleutel niet Opgeslagen, Keer terug om de instelling te voltooien',
  saveNewWidgetKey: 'Nieuwe widgetsleutel niet opgeslagen. Keer terug op de instelling te voltooien.',
  saveOrderAttachmentsError: 'Opslaan van bijlagen bij bestelling mislukt.',
  saved: 'Opgeslagen',
  search: 'Zoeken',
  searchAllContent: 'Alle content doorzoeken',
  searchCategories: 'Categorieën',
  searchConfiguration: 'Zoekconfiguratie',
  searchContent: 'Zoeken {content}',
  searchCriteria: 'Zoekcriteria',
  searchDocumoto: 'Zoeken door Documoto',
  searchFeatures: 'Zoekfuncties',
  searchFieldConfigDescription: 'De volgende systeemveldzoekinstellingen zijn alleen van toepassing op algemene zoekopdrachten in de Library, de zoekresultatenpagina en Snel toevoegen aan winkelwagen. Andere zoekfuncties (zoals zoeken in het Admin Center en Library waar gebruikt) worden niet beïnvloed.',
  searchInContent: 'Zoeken in {contentName}...',
  searchPlaceholder: 'Alle content doorzoeken...',
  searchPrompt: 'Alle content doorzoeken...',
  searchProperty: 'Zoek Eigenschap | Zoek Eigenschappen',
  searchResults: 'Zoekresultaten',
  searchResultsConfiguration: 'Configuratie van zoekresultaten',
  searchSettings: 'Zoekinstellingen',
  searchSettingsDescription: 'Deze instellingen regelen verschillende gedragingen, functies en resultaten bij het zoeken in de Library.',
  searchTerm: 'Zoekterm',
  searchTips: 'Tips om te zoeken:',
  searchType: 'Type',
  searchable: 'Zoekbaar',
  searchableFieldsSuccessfullyUpdated: 'Doorzoekbare velden succesvol bijgewerkt.',
  searchableTag: 'Zoekbare Tag',
  searchingInLanguage: 'Zoeken in {lang} alleen',
  searchingInTwoLanguages: 'Zoeken in {lang1} en {lang2} alleen',
  section: 'Sectie',
  select: 'Selecteren',
  selectAField: 'Selecteer een {field}',
  selectAll: 'Selecteer Alle',
  selectAndClose: 'Selecteren en Sluiten',
  selectChapters: 'Hoofdstuk(ken) selecteren',
  selectChildren: 'Kinderen Selecteren',
  selectFields: '{field} Selecteren',
  selectItem: 'Selecteer {item}',
  selectMedia: 'Media selecteren',
  selectPage: 'Geselecteerde Pagina',
  selectPages: 'Pagina(‘s) selecteren',
  selectTargetPage: 'Doelpagina Selecteren',
  selected: 'Geselecteerd',
  selectedTargetPage: 'Geselecteerde Doelpagina',
  send: 'Verzenden',
  sendReverificationEmail: 'Nieuwe verificatiemail versturen',
  sendVerificationEmail: 'Verificatiemail versturen',
  september: 'September',
  sequence: 'Reeks',
  serbianDescription: 'Servische beschrijving',
  serbianName: 'Servische naam',
  serviceUri: 'Service-URL',
  sessionLog: 'Sessielogboek',
  set: 'Instellen',
  setAsDefault: 'Instellen als Standaard',
  setPassword: 'Wachtwoord instellen',
  settings: 'Instellingen',
  settingsMessage: 'Werk uw gebruikersvoorkeuren en wachtwoord bij',
  shape: 'Vorm',
  shapeTool: 'Vormgereedschap',
  shared: 'Gedeeld',
  sharedCart: 'Gedeelde Winkelwagen | Gedeelde Winkelwagens',
  sharedCartDeleteContent: 'Dit zal deze Gedeelde Winkelwagen verwijderen voor alle Organisaties waarin hij gedeeld is.',
  sharedCartOrganizationContent: 'Selecteer de Organisaties die deze Gedeelde Winkelwagen kunnen gebruiken',
  sharedShoppingCartsEnabled: 'Gedeelde Winkelwagens Inschakelen',
  shoppingCartExportJob: 'Exporteren winkelwagentje',
  shoppingCartLoadingLongTime: 'Het winkelmandje wordt geladen. De pictogrammen van het winkelmandje wordt beschikbaar van zodra het proces is voltooid. Als het probleem blijft bestaan, neem contact op met uw Documoto Administrator voor ondersteuning.',
  showChapterTOCForHiddenPages: 'Toon Hoofdstuk TOC voor Verborgen Pagina‘s',
  showExportFromSearch: 'Export van Zoekresultaten Toestaan',
  showExportFromSearchHelp: 'Exporteren van een boekenlijst uit een zoekresultaat toestaan',
  showHelp: 'Help Weergeven',
  showIdentifierInLibrary: 'Media- en productpagina-Identificatoren weergeven in de bibliotheek',
  showIdentifierInSearch: 'Toon Media Identifier in Zoeken',
  showItem: '{item} Weergeven',
  showLess: 'Minder Bekijken',
  showMediaDescriptionFilter: 'Media Beschrijvingsfilter Weergeven',
  showMediaIdentifierFilter: 'Media Identificatiefilter Weergeven',
  showMediaNameFilter: 'Media Naamfilter Weergeven',
  showMore: 'Meer Bekijken',
  showOnlyExactMatches: 'Alleen exacte overeenkomsten weergeven',
  showOrganizationFilter: 'Organisatiefilter Weergeven',
  showPartNameFilter: 'Onderdeel Naamfilter Weergeven',
  showPartNumberFilter: 'Onderdeel Nummerfilter Weergeven',
  showRecentlyAdded: 'Onlangs Toegevoegd Weergeven',
  showRecentlyViewed: 'Onlangs Bekeken Weergeven',
  showSearchButton: 'Zoektoets Homepagina Weergeven',
  showSearchButtonHelp: 'Toets \'Ga naar Zoekopdracht\' weergeven in de Header van Bibliotheek',
  signature: 'Handtekening',
  size: 'Formaat',
  snapshot: 'Snapshot | Snapshots',
  solrSlaveSvrOverride: 'Basis URL‘s van SOLR slave-servers overschrijven',
  sortAsc: '{value} A-Z',
  sortDesc: '{value} Z-A',
  sortRelevant: 'Meest Relevant',
  sortType: 'Sorteertype',
  sourceBrowseFlow: 'Bron browseflow',
  sourceFile: 'Bronbestand',
  sourceFilename: 'Naam van bronbestand',
  spanishDescription: 'Spaanse beschrijving',
  spanishName: 'Spaanse naam',
  square: 'Vierkant',
  ssoConfiguration: 'SSO-configuratie',
  ssoIdpMetadataUrl: 'SSO IDP metadata URL',
  ssoLoginMaxAuthenticationAgeSeconds: 'Max authenticatieleeftijd van SSO-aanmelding in seconden',
  ssoSamlDnAttributeName: 'SSO SAML DN attributnaam',
  ssoSamlEmailAttributeName: 'SSO SAML e-mail attribuutnaam',
  ssoSamlMemberofAttributeName: 'SSO SAML lid van attribuutnaam',
  ssoSniForSsoMetadataRetrieval: 'SNI gebruiken voor ophalen van SSO-metadata',
  standard: 'Standaard',
  standardUserGroup: 'Standaard gebruikersgroep',
  startDate: 'Begindatum',
  startDateRequired: 'Een startdatum is vereist.',
  state: 'Staat',
  'static': 'Statisch',
  status: 'Status',
  statusCode: 'Statuscode | Statuscodes',
  stitchPages: 'Pagina’s Stikken',
  storeFilterValues: 'Filterwaarden opslaan',
  storeFilterValuesDescription: 'Door deze instelling in te schakelen, worden waarden opgeslagen die door gebruikers zijn ingesteld in hun zoekpaginafilters voor deze tag.',
  storeFrontAdmin: 'Winkelpui Beheer',
  storefront: 'Winkelpui',
  storefrontIntegration: 'Winkelpui Integratie | Winkelpui Integraties',
  storefrontIntegrationSubtitle: 'Deze instellingen beheren verschillende Winkelpui Integratie-elementen en opties. Wees voorzichtig bij het aanbrengen van wijzigingen. Contacteer Documoto Support voor meer info.',
  storefrontSettings: 'Winkelpui Instellingen',
  storefrontSettingsDescription: 'Deze instellingen beheren verschillende Winkelpui-elementen en opties. Wees voorzichtig bij het aanbrengen van wijzigingen. Contacteer Documoto Services voor meer info.',
  storefrontSettingsOrgDescription: 'Deze instellingen beheren verschillende Winkelpui-elementen en opties op Organisatieniveau. Wees voorzichtig bij het aanbrengen van wijzigingen. Contacteer Documoto Services voor meer info.',
  stroke: 'Slag',
  style: 'Stijl | Stijlen',
  styles: {
    colorHotpoint: 'Hotpointstandaard',
    inheritedFromOrg: 'Geërfd van organisatie {org}',
    inheritedFromSystem: 'Geërfd van systeemstandaard',
    inheritedFromTenant: 'Geërfd van tenant',
    invalidHexcode: 'Ongeldige hexadecimale code',
    organization: 'Organizatiestijl | Organizatiestijlen',
    organizationSaved: 'Organizatiestijlen opgeslagen',
    sampleNavigation: 'Navigatietabbladen',
    samplePrimary: 'Navigatie/Knoppen',
    sampleSelectedHotpoint: 'Geselecteerde hotpoints',
    tenant: 'Tenantstijl | Tenantstijlen',
    tenantSaved: 'Organizatiestijlen opgeslagen'
  },
  subChapter: 'Sub-hoofdstuk | Sub-hoofdstukken',
  subject: 'Onderwerp',
  subjectMessage: 'Er is een Onderwerp vereist',
  submit: 'Verzenden',
  submitPurchaseOrder: 'Inkooporder',
  submitRequestForQuote: 'Verzoek om Offerte',
  submitted: 'Ingediend',
  submittedBy: 'Ingediend door',
  submittedFilesMessage: '{fileCount} bestand(en) ingediend.',
  submitter: 'Indiener',
  submitterEmail: 'E-mail van de indiener',
  submitterFirstName: 'Voornaam van de indiener',
  submitterLastName: 'Achternaam van de indiener',
  submitterOrgName: 'Bedrijfsnaam van de indiener',
  submitterUserName: 'Gebruikersnaam van de indiener',
  success: 'Gelukt',
  successNotificationDuration: 'Toevoegen aan Winkelwagen - Duur van de Succesvolle Toastmeldingen',
  suffix: 'Suffix | Suffixes',
  suggestedKeywords: 'Voorgestelde trefwoorden',
  suggestedResults: 'Gesuggereerde resultaten',
  suggestion: 'Suggestie | Suggesties',
  sun: 'Zon',
  superAdminSettings: 'Instellingen superadmin',
  superadmin: 'Superadmin',
  supersede: 'Opvolgen',
  supersedeComplete: 'Wilt u de opvolging voltooien?',
  supersedeDiscardChanges: 'Opvolging verwerpen?',
  supersedeMainText: 'Opvolging vervangt een bestaand onderdeel door één of meerdere onderdelen, op elke Onderdelenpagina waar het oude onderdeel gevonden wordt. Het oude onderdeelnummer wordt verwijderd maar blijft vindbaar via tags zodat inhoud gevonden kan worden a.d.h.v. het oude nummer of nieuw(e) nummer(s).',
  supersedeMessage: 'Onderdeelupdates treden onmiddellijk in werking. Zoekfuncties zullen de updates in enkele minuten weergeven.',
  supersedeNotProcessed: 'Uw opvolging zal niet verwerkt worden.',
  supersedeReplacePart: 'Zoek één of meerdere onderdelen die onderdeel zullen vervangen',
  supersedeSuccessful: 'Opvolging Gelukt',
  supersedeWith: 'Onderdelen met ... Laten Opvolgen',
  superseded: 'Vervangend',
  supersededParts: 'Vervangende onderdelen',
  supplier: 'Leverancier | Leveranciers',
  supplierDescription: 'Het bedrijf dat dit onderdeel aanlevert',
  supplierKey: 'Leveranciersleutel',
  supportedDraftArchives: 'Niet ondersteund bedrag; conceptbestanden ondersteund: MDZ, PLZ',
  supportedImageFormats: 'Ondersteunde afbeeldingsformaten: GIF, JPG, JPEG, PNG',
  surroundWithQuotes: 'Zet aanhalingstekens rond meerdere zoektermen voor een exacte overeenkomst.',
  svgFinder: 'SVG Zoeker',
  swedishDescription: 'Zweedse beschrijving',
  swedishName: 'Zweedse naam',
  system: 'Systeem',
  systemAdmin: 'Systeembeheerder',
  systemFieldSearchAndFiltering: 'Zoeken in en filteren van systeemvelden',
  systemFields: 'Systeemvelden',
  systemName: 'Systeemnaam',
  systemStatus: 'Systeemstatus',
  systemVersion: 'Systeemversie',
  tabDelimited: 'Door tabs gescheiden',
  tableOfContents: 'Inhoudstafel',
  tabloid: 'Tabloid',
  tag: 'Tag | Tags',
  tagDeleteAffectedCount: 'Dit zal de tag en taginformatie verwijderen van {count} items.',
  tagDeleteAffectedNone: 'Geen enkel item maakt momenteel gebruik van deze tag.',
  tagEditor: {
    filterPrompt: 'De eerste 100 waarden worden weergegeven. Gebruik filter om meer te zien.',
    rangeBoundLengthInvalid: 'Grens kan niet meer dan {limit} cijfers bevatten.',
    tagEditorModal: 'Tag Editor Modaal',
    textfieldHelpText: 'Voer één of meerdere waarden in, gescheiden door puntkomma\'s. Voorbeeld: SN001; SN002'
  },
  tagManagerDeleteWarning: 'Alle bestaande media met {deleteCategoryName} zal niet meer over deze categorie beschikken na het verwijderen.',
  tagName: 'Tagnaam',
  tagSearchAndFiltering: 'Zoeken en filteren in tags',
  tagSearchAndFilteringHelpText: 'Tip: Sommige zoek- en filterinstellingen kunnen ook worden geconfigureerd in Tag Manager, dat u hier kunt vinden: ',
  tagSubmitAffected: 'Elk {type} inhoud zal automatisch de tag {tag} weglaten als aanvulling op de wijzigingen.',
  tagValue: 'Tagwaarde | Tagwaardes',
  tagValueMissing: 'U moet een tagwaarde invoeren',
  tagValueMultiple: 'Scheidingstekens met puntkomma voor meerdere ingaven',
  tagValueTooLong: 'Tagwaarde overschrijdt tekenlimiet van 25 | Tagwaarden overschrijden tekenlimiet van 25',
  tagsDeleteError: 'Eén of meerdere tags verwijderen is mislukt',
  tagsDeleteSuccess: 'Tags succesvol verwijderd',
  tagsDisplayMore: 'De eerste 100 waarden worden weergegeven. Gebruik filter om meer te zien.',
  tagsManager: 'Tagbeheer',
  tagsSaveError: 'Eén of meerdere tags opslaan is mislukt',
  tagsSaveSuccess: 'Tags succesvol opgeslagen',
  tagsUpdateError: 'één of meerdere tags bijwerken is mislukt',
  tagsUpdateSuccess: 'Tags succesvol bijgewerkt',
  targetBrowseFlow: 'Doel browseflow',
  taxon: 'Taxon',
  taxonomy: 'Taxonomie',
  template: 'Sjabloon | Sjablonen',
  templateEmailRecipients: 'Template E-mail Ontvangers',
  templateLayout: {
    addItem: 'Item toevoegen',
    addRow: 'Rij toevoegen',
    deleteColumn: 'Kolom verwijderen',
    deleteRow: 'Rij verwijderen',
    fullWidth: 'Volledige breedte',
    oneColumn: 'Eén kolom',
    threeColumns: 'Twee kolommen',
    twoColumns: 'Drie kolommen'
  },
  tenant: 'Tenant | Tenants',
  tenantAdmin: 'Tenant Beheer',
  tenantAdminMessage: 'Regelt de instellingen van de tenant',
  tenantCleanerJob: 'Onderhoud tenant',
  tenantConfiguration: 'Tenantconfiguratie',
  tenantEmailRecipients: 'Huurder E-mail Ontvangers',
  tenantEmailRecipientsOverrideMessage: 'Deze zullen worden overgeschreven wanneer de Organisatie E-mail Ontvangers worden gespecificeerd',
  tenantIndexQueueJob: 'Indexwachtrij tenant',
  tenantKey: 'Tenantsleutel',
  tenantKeyError: 'Tenantsleutel is niet uniek',
  tenantKeyMessage: 'Tenantsleutel moet uniek zijn',
  tenantLabelDeleteMessage: 'Door dit label te verwijderen, verschijnt de standaard Documotonaam opnieuw.',
  tenantLabelsPageText: 'Labels worden gebruikt om de namen van verschillende objecten die in de Bibliotheek en op de Admin-schermen van Documoto staan, te personaliseren.',
  tenantPrintSettingsDescription: 'Kies de standaard printinstelling die geldt voor alle tenants. Deze zal gebruikt worden voor het printen van alle boeken tenzij overschreven door de Organisatie of Media.',
  tenantReindexModulus: 'Modulus van herindexatie van tenant',
  tenantSettings: {
    collapseTOCLabel: 'Inhoudstafel Samenvouwen op Desbetreffende Pagina',
    defaultLocaleLabel: 'Standaardlocatie',
    defaultLocaleMessage: 'Standaardlocatie van tenant.',
    defaultSupplierLabel: 'Standaardleverancier',
    defaultSupplierMessage: 'Standaardleverancier van tenant',
    deleteMissingTranslationsOnPublishLabel: 'Ontbrekende vertalingen verwijderen bij het publiceren?',
    deleteMissingTranslationsOnPublishMessage: 'Inschakelen om gedeeltelijke vertalingen bij het publiceren te verwijderen',
    enableChapterIndexingLabel: 'Indexatie inschakelen voor Mediahoofdstukken',
    enableChapterIndexingMessage: 'Hoofdstukken indexeren',
    enableIndexingLabel: 'Indexeren bij publiceren',
    enableIndexingMessage: 'Schakelt indexering voor publiceren in.',
    excludePartsFromAccessControlChecksLabel: 'Onderdelen uitsluiten van toegangscontroleregels',
    excludePartsFromAccessControlChecksMessage: 'Indien ingeschakeld, onderdelen zijn zichtbaar ongeacht de mediatoegangscontroles.',
    exportPgAsHashLabel: 'Exporteren van paginabestandsnaam als hashsleutel',
    exportPgAsHashMessage: 'Gebruik paginahashsleutels als paginabestandsnamen in geëxporteerde inhoud',
    helpUrlLabel: 'Standaard Help-URL',
    helpUrlMessage: 'De URL van een alternatief hulpsysteem.',
    hotPointLinkPageInBookOnlyLabel: 'Pagina Hotpoint-links in Book Only',
    hotPointLinkPageInBookOnlyMessage: 'Hotpoint-links van pagina’s in Book Only',
    lockPartTrOnPublishLabel: 'Gedeeltelijke vertalingen bij het publiceren vergrendelen',
    lockPartTrOnPublishMessage: 'Voorkomt dat gedeeltelijke vertalingen gewijzigd worden tijdens het publiceren',
    mediaTimestampLabel: 'Media Tijdstempel bij Toegangscontrole Wijziging Bijwerken',
    mediaTimestampMessage: 'Schakel deze optie in als een wijziging in de mediacategorieën voor toegangscontrole de tijdstempel van de media moet bijwerken.',
    publisherDefaultUom: 'Uitgever Standaard UOM',
    publishingContactLabel: 'Publicatiecontact E-mail',
    publishingContactMessage: 'Het standaard e-mailadres dat e-mails zal ontvangen wanneer er een inhoudsprobleem gerapporteerd wordt.',
    replaceHotpointLabel: 'Hotpointlinks Altijd Vervangen bij Publicatie',
    replaceHotpointMessage: 'Enkel voor publicatie van Docustudio.',
    ssoLoginSystemLabel: 'SSO-aanmeldsysteem',
    ssoLoginSystemMessage: 'Identiteitsprovidersysteem voor SSO.',
    userPasswordExpirationLabel: 'Aantal dagen waarna het gebruikerswachtwoord verloopt',
    userPasswordExpirationMessage: 'Aantal dagen waarna wachtwoorden opnieuw moeten worden ingesteld; blanco zorgt ervoor dat ze nooit verlopen'
  },
  tenantSettingsSaved: 'Huurderinstellingen Opgeslagen',
  tenantSettingsSubtitle: 'Deze instellingen beheren eigenschappen en gedragingen van de huurder. Wees voorzicht bij het wijzigen ervan. Neem contact op met Documoto Services voor meer informatie',
  tenantSettingsTitle: 'Huurderinstellingen',
  tenantSuppliers: 'Tenantleveranciers',
  tenantType: 'Tenanttype',
  tenantWebserviceUser: 'Tenant webservicegebruiker',
  text: 'Tekst',
  textArea: 'Tekstgebied',
  textColor: 'Tekstkleur',
  textField: 'Tekstveld',
  textFile: 'Tekstbestand (CSV, TXT)',
  textTool: 'Tekstgereedschap',
  threeD: {
    addFile: 'Voeg een 3D Part File toe',
    beforeSaveModal: {
      message: 'Wilt u dit bestand overal vervangen waar het voorkomt, of wilt u het alleen aan dit onderdeel koppelen? Als u kiest om het bestand om te vervangen, zal het volgende gebeuren:',
      messageBulletOne: '{count} onderdelen worden bijgewerkt met dit nieuwe CAD-bestand',
      messageBulletOneForContent: '{count} {contentType} wordt bijgewerkt met dit nieuwe CAD-bestand',
      messageBulletTwo: 'De eerdere versie van dit bestand wordt verwijderd uit het Documoto-bestandssysteem',
      tip: 'Tip: Om te voorkomen dat bestanden worden overschreven tijdens het toevoegen van bijlagen, kunt u de bestandsnaam van het bestand dat u wilt toevoegen, wijzigen voordat u het importeert.',
      title: 'Er bestaat al een CAD-bestand in Documoto met deze bestandsnaam.'
    },
    deleteTitle: 'Weet u zeker dat u deze 3D-weergave wilt verwijderen?',
    drawMode: {
      hiddenLines: 'Verborgen lijnen',
      label: 'Tekenmodus',
      shaded: 'Met schaduw',
      wireframe: 'Draadraster',
      wireframeShaded: 'Draadraster met schaduw'
    },
    explode: 'Uitvouwen',
    failureCreatingBomAssociations: 'Maken van BOM-koppelingen voor 3D-model mislukt.',
    fileSizeModal: {
      message: 'De maximaal toegestane bestandsgrootte in Documoto is 25 megabytes. Het bestand dat u probeert te uploaden heeft de maximale grootte overschreden en kan niet worden geladen. Klik op “OK” om door te gaan.',
      title: 'Maximale bestandsgrootte overschreden'
    },
    fileSizeModalWarning: {
      message: 'De maximale toegestane bestandsgrootte in Documoto is {size} megabytes. Eén van de bestanden die u probeert te uploaden, overschrijdt deze limiet en kan niet worden geladen. Klik op "OK" om verder te gaan.',
      title: 'Maximale bestandsgrootte overschreden'
    },
    freeTierCurrentCount: 'Je hebt {count} van 15 actieve 3D-modellen in de gratis tier. Van zodra je deze limiet bereikt, kun je geen nieuwe pagina\'s meer publiceren met 3D-modellen. Neem contact op met je Customer Success Manager om je abonnement te upgraden.',
    freeTierExceededError: 'Deze pagina met een 3D-model publiceren is niet toegelaten.',
    freeTierExceededOption1: 'Neem contact op met uw Customer Success Manager om uw abonnement te upgraden.',
    freeTierExceededOption2: 'Verwijder het 3D-model van het paginaconcept om het te publiceren.',
    freeTierExceededTitle: 'U hebt de limiet van 15 actieve 3D-modellen overschreden.',
    illustrationLabel: '2D-weergave',
    invalidFile: 'Ongeldig bestand ingediend voor uploaden',
    mapModelToBom: 'Model aan BOM toewijzen',
    modelLabel: '3D-model',
    modelLabelMobile: '3D',
    noBomPartsMatch3dPartNumbers: 'Kan geen BOM-onderdelen vinden die overeenkomen met 3D-modelonderdeelnummers',
    noPartsMatchRegEx: 'Geen BOM-onderdelen komen overeen met reguliere expressie',
    orientation: 'Oriëntatie',
    orientationAndProjection: {
      back: 'Achterkant',
      bottom: 'Onderkant',
      front: 'Voorkant',
      isometric: 'Isometrisch',
      left: 'Links',
      orthographic: 'Orthografisch',
      perspective: 'Perspectief',
      projection: 'Projectie',
      right: 'Rechts',
      top: 'Bovenkant'
    },
    partNumberProperty: 'Onderdeelnummer eigenschap',
    partNumberRegex: 'Onderdeelnummer regex',
    partNumbersInModel: 'Onderdeelnummers in model',
    resetCamera: 'Camera opnieuw instellen',
    setAsDefaultView: 'Instellen als standaard weergave',
    setAsDefaultViewTooltip: 'Stel deze oriëntatie en dit zoomniveau in als standaard startweergave.',
    slice: {
      label: 'Snede',
      planeX: 'Snijvlak X',
      planeY: 'Snijvlak Y',
      planeZ: 'Snijvlak Z',
      reset: 'Snijvlak opnieuw instellen',
      section: 'Snijvlaksectie wisselen',
      visibility: 'Snijvlakzichtbaarheid wisselen'
    },
    successfullyCreatedBomAssociations: 'Succesvol aangemaakt {count} koppelingen van 3d-model met BOM',
    successfullySavedDefaultView: 'Standaard weergave succesvol opgeslagen',
    supportedFilesMessage: 'Documoto ondersteunt vele CAD-bestandformaten. Controleer het Support Center als u niet zeker weet of uw CAD-bestandsformaat wordt ondersteund.',
    threeD: '3D',
    toolsLabel: '3D Tools',
    topAssemblyFilename: 'Bestandsnaam Top Assembly',
    topAssemblyFilenameInvalid: 'Het assemblagebestand van het hoogste niveau staat niet in de bestandslijst',
    topAssemblyFilenameRequired: 'Bestandsnaam Top Assembly is vereist',
    viewerControls: 'Viewercontroles',
    viewerSettings: 'Instellingen 3D-viewer',
    viewerTitle: '3D Viewer'
  },
  thu: 'Don.',
  thumbnail: 'Miniatuur',
  thumbnailDeleted: 'Miniatuur Verwijderen Gelukt',
  thumbnailDeletedError: 'Miniatuur Verwijderen Mislukt',
  thumbnailReapplyWarning: 'Het systeem kan een miniatuur opnieuw toepassen op basis van inhoud van de media. Dit kan enkele minuten in beslag nemen.',
  thumbnailResizeTooltip: 'Verkleint/vergroot miniaturen tot maximaal 500x500 pixels, indien aangevinkt',
  thumbnailUpdated: 'Miniatuur Bijwerken Gelukt',
  thumbnailUpdatedError: 'Miniatuur Bijwerken Mislukt',
  title: 'Titel',
  to: 'Aan',
  toDate: 'Tot datum',
  toGetStarted: 'om te beginnen.',
  toastNotifications: 'Toastmeldingen',
  toc: 'Inhoudsopgave',
  tocClipBoardSuccessTitle: 'Gekopieerd naar Klembord',
  tocClipBoardWarningText: 'WAARSCHUWING: Wijzigingen die niet zijn opgeslagen, kunnen niet naar uw klembord worden gekopieerd',
  tocClipBoardWarningTitle: 'Gekopieerd naar Klembord',
  tocDisplayingFirstValues: 'De eerste 100 waarden worden weergegeven. Gebruik filter om meer te zien.',
  tocDuplicateWarningText: 'Er werd een dubbele pagina gedetecteerd in een hoofdstuk. Het duplicaat werd verwijderd.',
  tocEmptyMessage: 'Zo te zien heeft u nog geen Inhoudstafel aangemaakt',
  tocMissingChapterName: 'Hoofdstuknaam Ontbreekt',
  tocModalTableCaption: 'Tag Editor Modaal',
  tocNothingSelected: 'Niets Geselecteerd',
  tocOpenEditor: 'Editor Openen',
  tocSaveRequired: 'Opslaan vereist alvorens hoofdstukdetails bij te werken',
  tocState: 'Beginstatus van de Inhoudstafel',
  tocThumbnailDeleteFailTitle: 'Miniatuur Verwijderen Mislukt',
  tocThumbnailDeleteSuccessTitle: 'Miniatuur Verwijderen Gelukt',
  tocThumbnailUploadFailTitle: 'Miniatuur Uploaden Mislukt',
  tocThumbnailUploadSuccessTitle: 'Miniatuur Uploaden Gelukt',
  tocTranslationMessage: 'De naam en optionele beschrijving van dit hoofdstuk',
  tocUntitledPage: 'Pagina Zonder Titel',
  togglePage: 'Pagina wisselen',
  tooManySelections: 'Lijst overschrijdt selectielimiet van {limit}',
  top: 'Boven',
  total: 'Totaal',
  totalItems: 'Totaal Aantal Items',
  translation: 'Vertaling | Vertalingen',
  translationHelpTextItem: 'De naam en optionele beschrijving van dit {item}',
  'true': 'Waar',
  tryAgain: 'Gelieve opnieuw te proberen.',
  trySearchingToc: 'Probeer naar een woord te zoeken dat je ziet of je herinnert en de lijst wordt onmiddellijk kleiner. De weergave verandert pas als je op een resultaat klikt.',
  tryThis: 'Probeer dit',
  tue: 'Di.',
  turkishDescription: 'Turkse beschrijving',
  turkishName: 'Turkse naam',
  twoSided: 'Tweezijdig',
  type: 'Type | Types',
  typeAtLeastTwoChars: 'Typ tenminste 2 tekens om een lijst met overeenkomsten te bekijken.',
  typeSearchCriteriaAlreadySet: 'Verwijder het geselecteerde zoekcriterium "Type" om de wijzigingen toe te passen.',
  typeToConfirm: 'Typ {value} om te bevestigen',
  typography: 'Typografie',
  ukraineDescription: 'Oekraïense beschrijving',
  ukraineName: 'Oekraïense naam',
  unableToRetrieveResults: 'Kon resultaten voor uw vraag/zoekopdracht niet verzamelen',
  unauthorized: 'Niet-gemachtigd',
  unknownError: 'Onbekende fout, gelieve contact op te nemen met Documoto Support via support{\'@\'}documoto.com voor hulp',
  unknownInput: 'Onbekend invoertype:',
  unknownPart: 'Onbekend Onderdeel',
  unknownType: 'Onbekend type',
  unsavedAPIKeyWarning: 'Uw API-Sleutel gaat verloren als u niet Terugkeert',
  unsavedChanges: 'U heeft wijzigingen die niet zijn opgeslagen. Verdergaan?',
  unsavedChangesWarning: 'Uw wijzigingen zullen verloren gaan als u ze niet opslaat.',
  unsavedWidgetKeyWarning: 'Uw widgetsleutel zal verloren gaan als u niet terugkeert.',
  unsupportedBrowserMessage: 'We hebben deze toepassing gebouwd met de nieuwste technologie. Dit zorgt dat de toepassing sneller en eenvoudiger is in gebruik. Helaas ondersteunt uw browser deze technologieën niet.',
  untitledOrg: 'Naamloze Organisatie',
  unverified: 'Niet-geverifieerd',
  uom: 'Maateenheid',
  update: 'Update',
  updateFailed: 'Bijwerken mislukt',
  updateIndex: 'Index Bijwerken',
  updatePassword: 'Wachtwoord Bijwerken',
  updatePasswordMessage: 'Wachtwoord succesvol bijgewerkt',
  updatePasswordPending: 'Wachtwoord wijzigen opslaan in behandeling.',
  updated: 'Bijgewerkt',
  upgradeBrowser: 'Gelieve uw browser te upgraden.',
  upload: 'Uploaden',
  uploadComplete: 'Uploaden Voltooien',
  uploadFileSizeLimitExceeded: 'Bestand overschrijdt de maximale bestandsgrootte voor weergave in de app.',
  uploadInProgress: 'Bezig met Uploaden',
  uponSavingDisabledTenant: 'Na het opslaan van deze pagina met deze instelling ingeschakeld, zal het volgende gebeuren:',
  uponSavingThisLicense: 'Na het opslaan van deze pagina met de deze instelling, MOET U HET VOLGENDE DOEN:',
  upperBound: 'Bovengrens',
  usCurrency: 'USD',
  useDefaultCartColumns: 'Gebruik Standaard Kolommen Winkelwagen',
  useDefaultPartsListColumns: 'Standaard Kolommen Onderdelenlijst',
  useSequentialPageNumbering: 'Opeenvolgende Paginanummering Gebruiken',
  useSniForSsoMetadataRetrieval: 'SNI gebruiken voor ophalen van SSO-metadata',
  user: 'Gebruiker',
  userAddress: 'Gebruikersadres | Gebruikersadressen',
  userCount: 'Gebruikerstelling',
  userEditable: 'Aanpasbaar Door Gebruiker',
  userExpirationDate: 'Vervaldatum van de gebruiker',
  userExpirationDateInvalid: 'Vervaldatum van de gebruiker moet worden ingevoerd',
  userGroup: 'Gebruikersgroep | Gebruikersgroepen',
  userGroupEmpty: 'Gebruikersgroepen kunnen niet leeg zijn',
  userGroupType: 'Type gebruikersgroep',
  userGroupUniqueMessage: 'Deze naam moet anders zijn dan alle andere Gebruikersgroepnamen voor deze tenant',
  userGroupUsers: 'Gebruikersgroep Gebruikers',
  userSettings: 'Gebruikersinstellingen',
  userVerificationEmailBody: 'E-mailtekst voor gebruikersverificatie',
  userVerificationEmailFieldsValidation: 'De velden voor de verificatie-e-mail van de gebruiker moeten óf allebei niet leeg zijn, óf allebei leeg zijn',
  userVerificationEmailSubject: 'E-mailonderwerp voor gebruikersverificatie',
  username: 'Gebruikersnaam',
  usernameEmpty: 'Gebruikersnaam mag niet leeg zijn',
  users: 'Gebruikers',
  usersWillReceiveAnUnauthorizedError: 'Gebruikers zullen een fout “Unauthorized” krijgen wanneer ze proberen om aan te melden in de tenant.',
  validate: 'Valideren',
  validateTenantDirectories: {
    buttonLabel: 'Inhoudmappen valideren',
    error: 'Mislukt om mappen te valideren',
    success: 'Tenantmappen valideren'
  },
  validationMessage: 'Validatiebericht | Validatieberichten',
  value: 'Waarde',
  valueGteError: 'Waarde moet kleiner zijn dan of gelijk zijn aan {max}',
  valueLteError: 'Waarde moet groter zijn dan of gelijk zijn aan {min}',
  variantSKU: 'SKU-variant',
  vendorName: 'Naam van de leverancier',
  verificationEmailRequested: 'Verificatiemail wordt verzonden bij het opslaan.',
  verificationEmailSent: 'Verificatiemail verzonden. Wachtwoord niet ingesteld.',
  verified: 'Geverifieerd',
  verifyPassword: 'Wachtwoord Verifiëren',
  verifying: 'Verifiëren',
  version: 'Versie',
  vertical: 'Verticaal',
  video: 'Video | Videos',
  view: 'Weergave',
  viewAll: 'Alles bekijken',
  viewAllPagesAndBooks: 'Weergave: Alle pagina´s en boeken',
  viewAllResults: 'Alle resultaten bekijken',
  viewBooks: 'Weergave: Boeken',
  viewModeList: 'Lijstweergave',
  viewModeTable: 'Tabelweergave',
  viewMore: 'Meer bekijken',
  viewPages: 'Weergave: Pagina´s',
  viewWhereUsed: 'Waar gebruikt bekijken',
  views: 'Weergaven',
  visibility: 'Zichtbaarheid',
  visibilityDescription: 'Wie kan deze {entity} weergeven',
  visible: 'Zichtbaar',
  waitForUpload: 'Wacht tot de upload voltooid is.',
  watermark: 'Watermerk',
  watermarkFont: 'Lettertype watermerk',
  watermarkOpacityPercentage: '% doorzichtigheid van watermerk',
  watermarkOrientation: 'Oriëntatie van watermerk',
  watermarkSaveFailed: 'Watermerk opslaan mislukt.',
  watermarkSaved: 'Watermerk opgeslagen',
  watermarkSelectionRequired: 'Selectie van gebruikersnaam of tekst vereist.',
  watermarkText: 'Tekst watermerk',
  wed: 'Woe.',
  whereUsed: 'Waar gebruikt',
  whereUsedCountInSearchBar: 'Waar gebruikt telling in zoekbalk',
  whoCanViewComment: 'Wie kan deze opmerking bekijken?',
  wholesale: 'Groothandel',
  wholesalePrice: 'Groothandelprijs',
  wholesaleTotal: 'Totaal van groothandel',
  widget: 'Widget',
  widgetAuthHeader: 'Autorisatiewaarde van widget',
  widgetErrorConfig: 'Widget kon niet worden geïnitialiseerd omwille van een foutieve configuratie van de widget',
  widgetErrorInit: 'Kan Documoto-widget niet initialiseren',
  widgetErrorLocation: 'Kan de opgegeven content in de widget niet lokaliseren',
  widgetErrorMultipleLocations: 'Meerdere locaties gevonden voor de opgegeven content',
  widgetKey: 'Widgetsleutel | Widgetsleutels',
  widgetKeyAdmin: 'Admin widgetsleutel',
  widgetKeyCopied: 'Waarde van widgetautorisatie gekopieerd naar het Klembord',
  widgetKeyDeleteMsg: 'Het verwijderen van de widgetsleutel schakelt het gebruik ervan uit',
  widgetKeyDeleted: 'Widgetsleutel verwijderd',
  widgetKeyDeletedError: 'Fout bij verwijderen van widgetsleutel',
  widgetKeyManager: 'Widgetsleutelmanager',
  widgetKeyNameEmpty: 'Naam moet uniek zijn en is verplicht. Deze waarde wordt ook gebruikt voor rapportage- en logdoeleinden als gebruikersnaam voor elke widgetactiviteit',
  widgetKeyRegenError: 'Fout bij genereren van widgetsleutel',
  widgetKeyRegenMsg: 'Regenereren van deze widgetsleutel kan bestaande integraties uitschakelen',
  widgetKeyRegenTitle: 'Weet u zeker dat u deze widgetsleutel wil verwijderen?',
  widgetKeySaved: 'Widgetsleutel opgeslagen',
  widgetPermissions: 'Widgetgebruikers zijn alleen-lezen en de toegang tot functies wordt beheerd via de configuratie op widgetniveau. Standaardrechten voor gebruikersgroepen zijn niet van toepassing op widgetgebruikers. Toegangsrechten voor mediacategorieën wel. Ga verder met het toewijzen van toegangscontroles voor mediacategorieën.',
  widgetRefreshErrorMsg: 'Vernieuw jouw pagina om de gevraagde content te bekijken',
  widgetUserGroup: 'Widgetgebruikersgroep',
  widgetUserGroupDeleteMsg: 'Kan widgetgroep met gebruikers niet verwijderen',
  willBeAffected: 'zal beïnvloed worden.',
  willBeDeleted: '{content} zal verwijderd worden.',
  willBeInsertedIntoItem: '{name} zal ingevoegd worden voor {item}',
  willBeUpdated: 'zal bijgewerkt worden.',
  year: 'Jaar',
  yourEmailAddress: 'Uw e-mailadres',
  zipCode: 'Postcode',
  zoomHotpointToCanvas: 'Hotpoint zoomen tot Canvasformaat',
  zoomIn: 'Inzoomen',
  zoomOut: 'Uitzoomen'
};
/* eslint-enable max-len */
